<template>
  <v-app id="inspire">
    <Header type="return" @changeClient2="needSave = true" />
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10" v-if="visitorDesktop && visitorDesktop.client">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Карточка клиента</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Монитор продаж /</span> Карточка клиента</div>
                </div>
                <div>

                  <v-progress-circular
                    v-if="cardHistoryLoading"
                    color="green"
                    indeterminate
                    style="width:20px; height:20px;"
                  ></v-progress-circular>

                  <v-btn type="button" class="button__lighten-success" style="margin-right:20px; margin-left:10px; margin-top:0px !important;" @click="getCardHistory">
                    <span >История карточки</span>
                  </v-btn>
                  <v-btn
                      color="#629F33"
                      class="button__success"
                      @click="chooseDeal"
                  >
                    Новая сделка
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row v-for="deal in visitorDesktop.client.activeDeals" :key="deal.id">
              <v-col cols="12" v-if="deal.result !== 'Успех'">
                <v-sheet max-height="100px" rounded="lg" class="card tabs-sheet border-gray">
                  <div class="card-title">
                    {{ deal.name }}
                  </div>
                  <div class="status-line mt-2">
                    <div
                        class="status-line__status"
                        v-for="(stage, index) in deal.type.stages"
                        @click="setActiveStage(deal, stage)"
                        :style="deal.stage.number >= index + 1 ? 'background-color: ' + stage.colour : ''"
                        :key="stage.id"
                    >
                      {{ stage.name }}
                    </div>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <div class="grid" v-if="visitorDesktop">
              <div class="client-info">
                <div class="block">
                  <div class="personal-data" v-if="visitorDesktop && visitorDesktop.client && visitorDesktop.client.client_id && visitorDesktop.client.client_id === client_id">

                    <div class="personal-data__photo">
                      <img
                          :src="visitorDesktop.client.photo ? visitorDesktop.client.photo : '/playground_assets/mediumcamera3282-238l.svg'"
                          :style="visitorDesktop.client.photo ? 'height: 100px; width: 100px; border-radius: 145px;' : 'height: 37px; width: 46px'"
                      />
                    </div>
                      <div v-if="visitorDesktop.client.status && visitorDesktop.client.status.name && (visitorDesktop.client.status.id == 'ПотенциальныйЧленКлуба' || visitorDesktop.client.status.id == 'ПотенциальныйКлиентКлуба')" style="background-color:#ffc107;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>{{ visitorDesktop.client.status.name }}</span>
                      </div>
                      <div v-else-if="visitorDesktop.client.status && visitorDesktop.client.status.name && (visitorDesktop.client.status.id == 'БывшийЧленКлуба' || visitorDesktop.client.status.id == 'БывшийКлиентКлуба' || visitorDesktop.client.status.id == 'Отказ')" style="background-color:#f44336;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>{{ visitorDesktop.client.status.name }}</span> 
                      </div>
                      <div v-else style="background-color:#8bc34a;margin-top:10px;border-radius:50px; height:35px; width:200px;color:#fff;display:flex; align-items:center; justify-content:center;">
                        <span>Член клуба</span>
                      </div>
                    <div class="personal-data__info">
                      <div class="fio">{{ visitorDesktop.client.name }}</div>
         
                      <div class="card-subtitle">
                        
                        <span v-if="+visitorDesktop.client.age < 100">{{ visitorDesktop.client.age }} </span>
                        
                        <span v-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]) && (+visitorDesktop.client.age === 21) || (+visitorDesktop.client.age === 31) || (+visitorDesktop.client.age === 41) || (+visitorDesktop.client.age === 51) || (+visitorDesktop.client.age === 61) || (+visitorDesktop.client.age === 71)"> год </span>
                        <span v-else-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]) && (+visitorDesktop.client.age === 22) || (+visitorDesktop.client.age === 32) || (+visitorDesktop.client.age === 42) || (+visitorDesktop.client.age === 52) || (+visitorDesktop.client.age === 62) || (+visitorDesktop.client.age === 72) || (+visitorDesktop.client.age === 23) || (+visitorDesktop.client.age === 33) || (+visitorDesktop.client.age === 43) || (+visitorDesktop.client.age === 53) || (+visitorDesktop.client.age === 63) || (+visitorDesktop.client.age === 73) || (+visitorDesktop.client.age === 24) || (+visitorDesktop.client.age === 34) || (+visitorDesktop.client.age === 44) || (+visitorDesktop.client.age === 54) || (+visitorDesktop.client.age === 64) || (+visitorDesktop.client.age === 74)"> года </span>
                        <span v-else-if="(visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1])"> лет </span>
                        <span v-else>-</span>
                        <span v-if="visitorDesktop.client.birthday && !visitorDesktop.client.birthday.split('000')[1]">({{ visitorDesktop.client.birthday }})</span>
                        <span v-else></span>

                      </div>

                      <div class="card-title mt-3">
                        Посещений: {{ visitorDesktop.client.count_visit }}
                      </div>
                      <!-- <div v-if="visitorDesktop.client.last_visit && visitorDesktop.client.last_visit.date_end" class="card-subtitle mt-1">
                        Последнее посещение {{formatDate(visitorDesktop.client.last_visit) }}
                      </div>
                      <div v-else class="card-subtitle mt-1">
                        Последнее посещение: - 
                      </div> -->

                      <div v-if="visitorDesktop.client.visits_today && visitorDesktop.client.visits_today[0] && visitorDesktop.client.visits_today[0].active">
                        Клиент в клубе {{visitorDesktop.client.visits_today[0].duration}} с {{visitorDesktop.client.visits_today[0].date_start}}
                      </div>
                      <div v-else-if="visitorDesktop.client.last_visit && visitorDesktop.client.last_visit.date_end" class="card-subtitle mt-1">
                        Последнее посещение {{formatDate(visitorDesktop.client.last_visit) }}
                      </div>
                      <div v-else class="card-subtitle mt-1">
                        Последнее посещение: - 
                      </div>
                      
                    </div>
                    <v-btn :to="{ name: 'CardClient', params: {client_id: client_id} }" class="button button__lighten"
                           style="min-width: 100% !important; margin-top: 30px !important;">
                      Профиль клиента
                    </v-btn>
                  </div>
                  <div v-else class="personal-data">
                    
                    <div class="personal-data__photo">
                      <img
                          :src="'/playground_assets/mediumcamera3282-238l.svg'"
                      />
                    </div>
                      <div>
                        <span>Загрузка данных...</span>
                      </div>
  
                    <div class="personal-data__info">
                      <div class="fio">Загрузка данных...</div>
                      <div class="birthday-reg-day">
                        <span>Загрузка данных...</span>
                      </div>
                      <div class="card-title mt-3">
                        Посещений: Загрузка данных...
                      </div>
        
                    </div>
                  </div>

                  <div class="personal-info">
                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Карта</div>
                        <div class="right justify-flex-end">
                          <button class="btn-icon">
                            <Icon
                                iconName="plus-circle"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                strockeWidth="1"
                                @click="dialogCard = true"
                            />
                          </button>
                        </div>
                      </div>
                      <div class="item__value item__grid" v-for="card in visitorDesktop.client.cards"
                           :key="card.card_id">
                        <div :class="card.card_status === 1 ? 'left active_status' : 'left block_status'" @click="cardInfo(card)">{{ card.card_number }}</div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Лицевые и бонусные счета</div>
                        <div class="right">
                          <v-btn dark class="gray w-100" @click="modalBillPayment">
                            Внести
                          </v-btn>
                        </div>
                      </div>
                      <div class="item__value item__grid" v-for="bill in visitorDesktop.client.main_bonus_bill"
                           :key="bill.id">
                        <div class="left" style="cursor:pointer;" @click="getDepositItem(bill)">{{ bill.name }}</div>
                        <div class="right text-right color-black" style="cursor:pointer;" @click="getDepositItem(bill)">{{ bill.balance }} ₽</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Телефон</div>
                        <div class="right">
                       
                        </div>
                      </div>
                      <div class="item__value item__grid">
                        <div class="left">{{ visitorDesktop.client.phone[0] }}</div>
                        <div class="right">
                          <button class="btn-icon ml-auto" @click="modalPhone(visitorDesktop.client.phone[0])">
                            <v-icon small>mdi-phone</v-icon>
                          </button>
                        </div>
                      </div>
                      <div class="item__value item__grid" v-if="visitorDesktop.client.phone[1]">
                        <div class="left">{{ visitorDesktop.client.phone[1] }}</div>
                        <div class="right">
                          <button class="btn-icon ml-auto" @click="modalPhone(visitorDesktop.client.phone[1])">
                            <v-icon small>mdi-phone</v-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Родственники</div>
                        <div class="right justify-flex-end">
                          <button class="btn-icon" @click="addRelation">
                            <Icon iconName="plus-circle" width="16" height="16"
                                  viewBox="0 0 16 16" strockeWidth="1"/>
                          </button>
                        </div>
                      </div>
                      <div class="item__value item__grid" v-for="relative in visitorDesktop.client.relatives"
                           :key="relative.id">
                        <div class="left" @click="editRelation(relative)">{{ relative.full_name }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Персональный менеджер</div>
                        <div class="right">
                          <v-btn dark class="gray w-100" @click="changePersonalManager">
                            Изменить
                          </v-btn>
                        </div>
                      </div>
                      <div class="item__value item__grid">
                        <div class="left">{{ visitorDesktop.client.manager.name }}</div>
                      </div>
                    </div>
                    
                    <div class="item">
                      <div class="item__head item__grid">
                        <div class="left">Маркетинг:</div>

                      </div>
                    </div>
                    <div class="item">
                        <div class="item__head item__grid">
                          <div class="left" style="margin-right: 10px;">Канал: </div>
                          <div class="right">
                            <v-btn dark class="gray w-100" @click="dialogPersonalPlatform = true">
                              Изменить
                            </v-btn>
                          </div>
                        </div>
                        <div class="item__value item__grid">
                          <div class="left">Канал: {{ (visitorDesktop.client.advertising_platform  && visitorDesktop.client.advertising_platform.length > 0) ? visitorDesktop.client.advertising_platform.name : ''}}</div>
                        </div>
                      </div>

                      <div class="item">
                        <div class="item__head item__grid">
                          <div class="left" style="margin-right: 10px;">Источник: </div>
                          <div class="right">
                            <v-btn dark class="gray w-100" @click="dialogPersonalSource = true">
                              Изменить
                            </v-btn>
                          </div>
                        </div>
                        <div class="item__value item__grid">
                            <div class="left">{{ visitorDesktop.client.advertising_source.name }}</div>
                            <div class="right">
                              <div v-if="visitorDesktop.client.advertising_source_value && visitorDesktop.client.advertising_source_value.id">
                                <!-- :to="{name: 'CardClientNew', params: {client_id: visitorDesktop.client.advertising_source_value.id}}" -->
                                <div
                                    @click="refreshClient(visitorDesktop.client.advertising_source_value.id)"
                                    style="text-decoration: none; color: black; cursor:pointer;">{{ visitorDesktop.client.advertising_source_value.name }}
                                </div>
                              </div>
                              <span v-else>
                                Не найден
                              </span>
                            </div>
                          </div>
                      </div>

                      
                      <div class="item" v-if="listNotes && listNotes.notes">
                            <div class="item__head item__grid">
                              <div class="left">Заметки</div>
                              <div class="right justify-flex-end">
                                <button class="btn-icon">
                                  <Icon
                                      iconName="plus-circle"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      @click="dialogNote = true, noteNewType = 1"
                                  />
                                </button>
                              </div>
                            </div>
                            <div class="item__value item__grid" v-for="note in listNotes.notes"
                                 :key="note.id">
                              <div class="left" v-if="note.type === 1">{{ note.note }}</div>
                              <div class="right text-right color-black" v-if="note.type === 1" style="cursor:pointer;" @click="deleteNote(note.id, 1)"> X </div>
                            </div>
                          </div>



                  </div>
                </div>
              </div>
              <div class="client-data">
                <v-tabs-items v-if="visitorDesktop.client.debts.length !== 0" v-model="tab">
                  <v-tab-item style="overflow-x: hidden; height:500px;">
                    <v-sheet v-if="visitorDesktop.client.debts.length !== 0" rounded="lg" class="card mb-5"
                             style="color: #D53025 !important;">
                      <span class="card-title">Задолженность {{ totalAmountDebt }} ₽</span>
                      <v-data-table
                          :headers="headersCredit"
                          :items="visitorDesktop.client.debts"
                          v-model="credits"
                          show-select
                          :hide-default-footer="true"
                          disable-pagination
                          item-key="buy.buy_name"
                          class="elevation-1 mt-3 custom__table"
                      >
                        <template v-slot:header.data-table-select="{ on, props }">
                          <v-tooltip
                              top
                              content-class="black tooltip-top"
                          >
                            Выбрать все
                            <template v-slot:activator="{ on: onTooltip }">
                              <v-simple-checkbox
                                  v-ripple
                                  color="#629F33"
                                  v-bind="props"
                                  v-on="{ ...on, ...onTooltip }"
                              ></v-simple-checkbox>
                            </template>
                          </v-tooltip>
                        </template>
                        <template v-slot:item.data-table-select="{ isSelected, select }">
                          <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected"
                                             @input="select($event)"></v-simple-checkbox>
                        </template>
                        <template v-slot:item.buy.buy_name="{item}">
                          <v-list-group
                              color="#1A1A1A"
                              class="debts"
                              :ripple="false"
                              :value="false"
                          >
                            <template v-slot:activator>
                              <v-list-item-title class="debt-title">
                                <router-link
                                    :to="{name: 'Sale', params: {client: visitorDesktop.client, buy_id: item.buy.buy_id, type: 'exist', for: 'client', deal: null}}"
                                    style="text-decoration: none; color: black">{{ item.buy.buy_name }}
                                </router-link>
                              </v-list-item-title>
                            </template>
                            <v-list-item
                                v-for="it in item.buy_list" :key="it.name"
                            >
                              <v-list-item-title>
                                <span class="debt-subtitle">{{ it.name }}</span>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list-group>
                        </template>
                        <template v-slot:item.amount_debt="{item}">
                          {{ item.amount_debt }} ₽
                        </template>
                      </v-data-table>
                      <div class="text-right mt-5">
                        <v-btn
                            v-if="credits.length !== 0"
                            dark
                            class="payment-button"
                            @click="modalPayment"
                            style="background-color: #D53025!important;color: #fff!important;"
                        >
                          {{ 'Оплатить ' + chosenAmountDebt + ' ₽' }}
                        </v-btn>
                        <v-btn
                            v-else
                            dark
                            class="payment-button"
                            style="background-color: #F1F1F1!important;color: #000!important;"
                        >
                          Оплатить
                        </v-btn>
                      </div>
                    </v-sheet>
                  </v-tab-item>
                </v-tabs-items>
                <v-sheet
                    max-height="80px"
                    rounded="lg"
                    style="padding: 20px 0;"
                >
                  <v-tabs
                      centered
                      id="horizontal_tabs"
                      class="custom__tab"
                      v-model="tab"
                  >
                    <v-tab
                        v-for="item in items"
                        :key="item.tab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
                <v-tabs-items v-model="tab" v-if="visitorDesktop">
                  <v-tab-item>
                    <div class="block mt-5">
                      <div class="task-buttons">
                        <v-btn dark class="my-btn gray" @click="addTask">
                          <Icon iconName="plus" width="16" height="16" viewBox="0 0 16 16"
                                strockeWidth="1"/>
                          Задача
                        </v-btn>
                        <v-btn dark class="my-btn gray" @click="dialogNote = true, noteNewType = 0">
                          <Icon iconName="plus" width="16" height="16" viewBox="0 0 16 16"
                                strockeWidth="1"/>
                          Заметки
                        </v-btn>
                        <v-btn dark class="my-btn gray" @click="addTag">
                          <Icon iconName="plus" width="16" height="16" viewBox="0 0 16 16"
                                strockeWidth="1"/>
                          Тег
                        </v-btn>
                      </div>
                      <div v-if="visitorDesktop.client.tags.length !== 0" class="tags-list">
                        <div v-for="tag in visitorDesktop.client.tags" :key="tag.tag_id" class="tag-item">
                          <span v-if="!tag.tag_name.split('#')[1]">#</span>{{ tag.tag_name }}
                        </div>
                      </div>
                      <div class="task-list">
                        <div class="task-list__day" v-if="visitorDesktop.client.crm.schedule.length !== 0">
                          <div class="task-list__day__day-name">
                            <span>Запланировано</span>
                          </div>
                          <div v-for="item in visitorDesktop.client.crm.schedule" :key="item.name">
                            <div class="task-list__day__tasks" style="padding:7px 0px 10px 0px;">
                              <div v-if="item.type === 'task'" class="task-list__day__tasks__task" @click="editTaskModal(item)">
                                <div class="task-header">
                                  <Icon
                                      iconName="clock"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      strocke="#767676"
                                  />
                                  <span class="task-date">{{ item.done ? item.date_end : formatDateTime(item.assigned_to) }} {{ item.user.name }}</span>
                                  <span class="task-title">{{ item.deal ? item.deal.name : '' }}</span>
                                </div>
                                <div class="task-content content-grid">
                                  <div class="check-div">
                                    <v-checkbox
                                        :id="item.id"
                                        color="#629F33"
                                        v-model="item.done"
                                        @change="checkTask(item.id,item.done)"
                                    ></v-checkbox>
                                  </div>
                                  <div>
                                    <span class="task-topic">{{ item.name }}</span>
                                    <div>
                                      {{ item.description }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="item.type === 'note'" class="task-list__day__tasks__task" @click="editNoteModal(item)">
                                <div class="task-header">
                                  <Icon iconName="file-text" width="16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="1" strocke="#767676"/>
                                  <span class="task-date">{{ item.date_create }}</span>
                                </div>
                                <div class="task-content">
                                  <div class="task-text">
                                    {{ item.note }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="task-list__day" v-if="visitorDesktop.client.crm.today.length !== 0">
                          <div class="task-list__day__day-name">
                            <span>Сегодня</span>
                          </div>
                          <div v-for="item in visitorDesktop.client.crm.today" :key="item.name">
                            <div class="task-list__day__tasks" style="padding:7px 0px 10px 0px;">
                              <div v-if="item.type === 'task'" class="task-list__day__tasks__task" @click="editTaskModal(item)">
                                <div class="task-header">
                                  <Icon
                                      iconName="clock"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      strocke="#767676"
                                  />
                                  <span class="task-date">{{ item.done ? item.date_end : item.date_create }} {{ item.user.name }}</span>
                                  <span class="task-title">{{ item.deal ? item.deal.name : '' }}</span>
                                </div>
                                <div class="task-content content-grid">
                                  <div class="check-div">
                                    <v-checkbox
                                        :id="`task-1`"
                                        :ref="`task-1`"
                                        color="#629F33"
                                        v-model="item.done"
                                        @change="checkTask(item.id,item.done)"
                                    ></v-checkbox>
                                  </div>
                                  <div>
                                    <span class="task-topic">{{ item.name }}</span>
                                    <div>
                                      {{ item.description }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="item.type === 'note'" class="task-list__day__tasks__task" @click="editNoteModal(item)">
                                <div class="task-header">
                                  <Icon iconName="file-text" width="16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="1" strocke="#767676"/>
                                  <span class="task-date">{{ item.date_create }}</span>
                                </div>
                                <div class="task-content">
                                  <div class="task-text">
                                    {{ item.note }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="task-list__day" v-if="visitorDesktop.client.crm.yesterday.length !== 0">
                          <div class="task-list__day__day-name">
                            <span>Вчера</span>
                          </div>
                          <div v-for="item in visitorDesktop.client.crm.yesterday" :key="item.name">
                            <div class="task-list__day__tasks" style="padding:7px 0px 10px 0px;">
                              <div v-if="item.type === 'task'" class="task-list__day__tasks__task" @click="editTaskModal(item)">
                                <div class="task-header">
                                  <Icon
                                      iconName="clock"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      strockeWidth="1"
                                      strocke="#767676"
                                  />
                                  <span class="task-date">{{ item.done ? item.date_end : item.date_create }} {{ item.user.name }}</span>
                                  <span class="task-title">{{ item.deal ? item.deal.name : '' }}</span>
                                </div>
                                <div class="task-content content-grid">
                                  <div class="check-div">
                                    <v-checkbox
                                        :id="`task-1`"
                                        :ref="`task-1`"
                                        color="#629F33"
                                        v-model="item.done"
                                        @change="checkTask(item.id,item.done)"
                                    ></v-checkbox>
                                  </div>
                                  <div>
                                    <span class="task-topic">{{ item.name }}</span>
                                    <div>
                                      {{ item.description }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="item.type === 'note'" class="task-list__day__tasks__task" @click="editNoteModal(item)">
                                <div class="task-header">
                                  <Icon iconName="file-text" width="16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="1" strocke="#767676"/>
                                  <span class="task-date">{{ item.date_create }}</span>
                                </div>
                                <div class="task-content">
                                  <div class="task-text">
                                    {{ item.note }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div class="task-list__day" v-if="visitorDesktop.client.crm.pasted.length !== 0">
                          <div class="task-list__day__day-name">
                            <span>Прошедшие</span>
                          </div>
                          <div v-for="(itemPast, keyPast) in visitorDesktop.client.crm.pasted" :key="itemPast[0].date_create">
                            <!-- <div style="display:flex;align-items: center; justify-content: center; margin-top:10px; background-color: rgb(185 218 146);">{{keyPast}}</div> -->
                            <div v-for="item in itemPast" :key="item.name" :attr-p="keyPast">
                              <div class="task-list__day__tasks" style="padding:7px 0px 10px 0px;" v-if="item.type">
                                <div v-if="item.type === 'task'" class="task-list__day__tasks__task" @click="editTaskModal(item)">
                                  <div class="task-header">
                                    <Icon
                                        iconName="clock"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        strockeWidth="1"
                                        strocke="#767676"
                                    />
                                    <span class="task-date">{{ item.done ? item.date_end : item.date_create }} {{ item.user.name }}</span>
                                    <span class="task-title">{{ item.deal ? item.deal.name : '' }}</span>
                                  </div>
                                  <div class="task-content content-grid">
                                    <div class="check-div">
                                      <v-checkbox
                                          :id="item.id"
                                          :ref="item.id"
                                          color="#629F33"
                                          v-model="item.done"
                                          @change="checkTask(item.id,item.done)"
                                      ></v-checkbox>
                                    </div>
                                    <div>
                                      <span class="task-topic">{{ item.name }}</span>
                                      <div>
                                        {{ item.description }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div v-if="item.type === 'note'" class="task-list__day__tasks__task" @click="editNoteModal(item)">
                                  <div class="task-header">
                                    <Icon iconName="file-text" width="16" height="16"
                                          viewBox="0 0 16 16" strockeWidth="1" strocke="#767676"/>
                                    <span class="task-date">{{ item.date_create }}</span>
                                  </div>
                                  <div class="task-content">
                                    <div class="task-text">
                                      {{ item.note }}
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div v-else>
                                  <div class="task-list__day__history my-2">
                                          <div class="task-list__day__history__item">
                                            <div class="action">{{ item.date }} {{ item.stage_out.name ? item.stage_out.name : item.deal_name }}</div>
                                            <div class="separator">
                                              <Icon iconName="chevron-down" width="16" height="16"
                                                    viewBox="0 0 16 16" strockeWidth="1" />
                                            </div>
                                            <div class="action">
                                              <div class="status">{{ item.stage_in.name }}</div>
                                            </div>
                                          </div>
                                        </div>
                              </div>
                        
                            </div>
<!-- 
                                <div v-for="itemH in visitorDesktop.client.crm.historyDeals" :key="itemH.name">
                                  
                                    <div v-for="it in itemH.history" :key="it.date">
                                      <div class="task-list__day__history my-2" v-if="it.date_ymd === keyPast">
                                        <div class="task-list__day__history__item">
                                          <div class="action">{{ it.date }} {{ it.stage_out.name ? it.stage_out.name : itemH.deal_name }}</div>
                                          <div class="separator">
                                            <Icon iconName="chevron-down" width="16" height="16"
                                                  viewBox="0 0 16 16" strockeWidth="1" />
                                          </div>
                                          <div class="action">
                                            <div class="status">{{ it.stage_in.name }}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    
                                </div> -->
                          </div>
                        </div>
                        <div class="task-list__day" style="margin-top:20px;" v-if="visitorDesktop.client.crm.historyDeals.length !== 0">
                          <div class="task-list__day__day-name mb-2">
                            <span>История</span>
                          </div>
                          <div v-for="item in visitorDesktop.client.crm.historyDeals" :key="item.deal_id+'-'+item.history[0].stage_in">
                            <div v-for="it in item.history" :key="it.stage_in">
                              <div class="task-list__day__history my-2">
                                <div class="task-list__day__history__item">
                                  <div class="action">{{ it.date }} {{ it.stage_out.name ? it.stage_out.name : item.deal_name }}</div>
                                  <div class="separator">
                                    <Icon iconName="chevron-down" width="16" height="16"
                                          viewBox="0 0 16 16" strockeWidth="1" />
                                  </div>
                                  <div class="action">
                                    <div class="status">{{ it.stage_in.name }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> 
                      </div>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                        :headers="headersSubscribe"
                        :items="visitorDesktop.client.productes"
                        no-data-text="Нет активных пакетов"
                        :hide-default-footer="true"
                        item-key="name"
                        disable-pagination
                        class="elevation-1 rounded-lg mt-5"
                    >
                      <template v-slot:item.product_name="{ item }">
                        <router-link :to="{ name: 'CardSubscribe', params: {client_id: client_id, product_id: item.product_id} }" style="align-items: center; text-decoration: none; color: #000">
                          {{ item.product_name }}
                        </router-link>
                      </template>
                      <template v-slot:item.product_activationdate="{ item }">
                        <span v-if="!item.product_activationdate.split('000')[1]">
                          {{ item.product_activationdate ? item.product_activationdate.split('T')[0].split('-')[2]+'.'+item.product_activationdate.split('T')[0].split('-')[1]+'.'+item.product_activationdate.split('T')[0].split('-')[0] : '' }}
                        </span>
                        
                      </template>
                      <template v-slot:item.product_lastdate="{ item }">
                        <span v-if="!item.product_lastdate.split('000')[1]">
                          {{ item.product_lastdate }}
                        </span>
                        
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-menu
                            bottom
                            left
                            offset-y
                            rounded="lg"
                            content-class="custom__menu"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                primary
                                icon
                                v-bind="attrs"
                                v-on="on"
                                class="dots-button__actions"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>


                          <v-list v-if="item.product_status !== 'Закрыт'" style="font-size: 13px; item-height:13px;">
                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="item.product_status !== 'Продан'"
                                                  :to="getRoute(item.product_status,item.product_id)"
                                              >
                                                <v-list-item-title>{{ getNameStatus(item.product_status) }}</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                  style="min-height:38px;"
                                                  v-if="item.product_status !== 'Продан' && item.activation_available === true"
                                                  :to="activateProduct(item.product_id)"
                                              >
                                                <v-list-item-title>Активировать</v-list-item-title>
                                              </v-list-item>


                                              <v-list-item
                                              style="min-height:38px;"
                                                  v-if="item.product_status === 'Продан' && item.activation_available === true"
                                                  @click="activateProduct(item.product_id)"
                                              >

                                                <v-list-item-title>{{ getNameStatus(item.product_status) }}</v-list-item-title>

                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ReturnService',
                                                  params: {client_id: visitorDesktop.client_id}
                                                }"
                                              >
                                                <v-list-item-title>Возврат</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: item.product_id, change_type: 'owner'}
                                                }"
                                              >
                                                <v-list-item-title>Оформить на другого клиента</v-list-item-title>
                                              </v-list-item>
                                              <v-list-item
                                              style="min-height:38px;"
                                                  :to="{
                                                  name: 'ChangeOwner',
                                                  params: {client_id: client_id, product_id: item.product_id, change_type: 'nomenclature'}
                                                }"
                                              >
                                                <v-list-item-title>Сменить номенклатуру</v-list-item-title>
                                              </v-list-item>

                                              <v-list-item
                                                style="min-height:38px;"
                                                    :to="{
                                                    name: 'ChangeOwner',
                                                    params: {client_id: client_id, product_id: item.product_id, product_lastdate: item.product_lastdate, change_type: 'changetime'}
                                                  }"
                                              >
                                                <v-list-item-title>Изменение срока действия</v-list-item-title>
                                              </v-list-item>

                                            </v-list>

                                            <v-list v-else>

                                            </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>

                    <v-data-table
                        :headers="headersService"
                        :items="visitorDesktop.client.services"
                        no-data-text="Нет активных услуг"
                        :hide-default-footer="true"
                        item-key="name"
                        class="elevation-1 rounded-lg mt-5 mb-2"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-menu
                            bottom
                            left
                            offset-y
                            rounded="lg"
                            content-class="custom__menu"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                primary
                                icon
                                v-bind="attrs"
                                v-on="on"
                                class="dots-button__actions"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>


                          <v-list>
                            <v-list-item
                                :to="{
                                  name: 'CreateLesson',
                                  params: {
                                    service_id: item.service_id
                                  }
                                }"
                            >
                              <v-list-item-title>Использовать</v-list-item-title>

                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                        :headers="headersDeals"
                        :items="visitorDesktop.client.arhiveDeals"
                        no-data-text="Нет закрытых сделок"
                        :hide-default-footer="true"
                        item-key="name"
                        class="elevation-1 rounded-lg mt-5 mb-2"
                    >
                      <template v-slot:item.name="{ item }">
                            <router-link
                            v-if="item.result === 'Успех'"
                                    :to="{name: 'Sale', params: {client: visitorDesktop.client, buy_id: item.buy_id, type: 'exist', for: 'client', deal: null}}"
                                    style="text-decoration: none; color: black">{{ item.name }}
                                </router-link>
                                <span v-else style="cursor:pointer;" @click="makeAlert">{{ item.name }}</span>
                        </template>
                    </v-data-table>



                  </v-tab-item>
                </v-tabs-items>

              </div>
            </div>
            <v-row justify="center">
              <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Родственник</h4>
                    </div>
                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="relationForm" @submit.prevent="addRelationSubmit">
                        <v-row>
                          <v-col
                              cols="12"
                          >
                            <v-switch
                                label="Существующий клиент"
                                style="height: 30px;"
                                color="#629F33"
                                inset
                                @change="changeState"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Телефон <span style="color: #D53025">*</span></label>
                            <v-text-field
                                v-model="phone"
                                :rules="phoneRules"
                                v-mask="'+7 (###) ###-##-###'"
                                label="Телефон"
                                required
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Фамилия</label>
                            <v-text-field
                                v-model="middle_name"
                                label="Фамилия"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Имя <span style="color: #D53025">*</span></label>
                            <v-text-field
                                v-model="first_name"
                                :rules="firstNameRules"
                                label="Имя"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Отчество</label>
                            <v-text-field
                                v-model="last_name"
                                label="Отчество"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Дата рождения</label>
                            <template>
                              <VueDatePicker
                                  no-title
                                  no-header
                                  color="#629f34"
                                  v-model="date_birthday"
                                  placeholder="Выбрать"
                              >
                                <template #activator="{ date }">
                                  <button
                                      class="button custom__datepicker"
                                      ref="activator"
                                      type="button"
                                      style="white-space: nowrap; width: 80% !important;"
                                  >
                                    {{ date }}
                                    <v-icon
                                        medium
                                        right
                                        class="ml-2"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </button>
                                </template>
                              </VueDatePicker>
                            </template>
                          </v-col>
                          <v-col
                              v-if="unsetClient"
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <label>Пол</label>
                            <v-select
                                v-model="gender"
                                :items="genderTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Пол"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              v-if="!unsetClient"
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Родственник</label>
                            <div class="d-flex">
                              <v-autocomplete
                                  colspan="1"
                                  :items="listClient ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск клиентов"
                                  no-data-text="Результатов не найдено"
                                  clearable
                                  color="#629F33"
                                  item-color="success"
                                  :search-input.sync="search"
                                  v-model="select"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                                  :no-filter=true
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                                  style="height: 30px;margin-top: 10px"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>
                              </v-autocomplete>
                              <!-- @click="fetchFeed(select)" -->
                              <v-btn v-show="select !== null"  @click="goToDesktop(select)"
                                     class="button__lighten-success ml-3"
                                     style="height: 40px !important;margin-top: 10px !important;">
                                <span @click="dialog = false">Рабочий стол</span>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Степень родства <span style="color: #D53025">*</span></label>
                            <v-select
                                v-if="listRelativesTypes"
                                v-model="relative_type"
                                :rules="relativeTypeRules"
                                :items="listRelativesTypes.relatives"
                                item-value="id"
                                item-text="name"
                                label="Степень родства"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <v-switch
                                v-model="is_representative"
                                label="Законный представитель"
                                color="#629F33"
                                inset
                                style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Лицевой счет</label>
                            <v-select
                                v-model="main_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Лицевой счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Бонусный счет</label>
                            <v-select
                                v-model="bonus_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Бонусный счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="mt-5">
                          <v-card-actions style="padding: 20px 10px !important;">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-card-actions>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogRelationEdit"
                  persistent
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Родственник</h4>
                    </div>
                    <v-btn icon @click="dialogRelationEdit = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="editRelationForm" @submit.prevent="editRelationSubmit">
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Родственник <span style="color: #D53025">*</span></label>
                            <div class="d-flex">
                              <v-text-field
                                  v-model="editRelationItems.name"
                                  label="Родственник"
                                  class="rounded-lg"
                                  outlined
                                  dense
                                  readonly
                                  style="height: 48px;margin-top: 10px"
                              ></v-text-field>
                              <!-- @click="fetchFeed(editRelationItems.id)" -->
                              <v-btn v-show="editRelationItems.id !== null" @click="goToDesktop(editRelationItems.id)"
                                     class="button__lighten-success ml-3"
                                     style="height: 40px !important;margin-top: 10px !important;">
                                     <span @click="dialogRelationEdit = false">Рабочий стол</span>
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Степень родства <span style="color: #D53025">*</span></label>
                            <v-select
                                v-if="listRelativesTypes"
                                v-model="editRelationItems.relative_type"
                                :rules="relativeTypeRules"
                                :items="listRelativesTypes.relatives"
                                item-value="id"
                                item-text="name"
                                label="Степень родства"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <v-switch
                                v-model="editRelationItems.is_representative"
                                label="Законный представитель"
                                color="#629F33"
                                inset
                                style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                            ></v-switch>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Лицевой счет</label>
                            <v-select
                                v-model="editRelationItems.main_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Лицевой счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                          >
                            <label>Бонусный счет</label>
                            <v-select
                                v-model="editRelationItems.bonus_bill"
                                :items="billTypes"
                                item-value="type_id"
                                item-text="type_name"
                                label="Бонусный счет"
                                class="rounded-lg"
                                outlined
                                dense
                                required
                                style="height: 30px;margin-top: 10px;"
                            ></v-select>
                          </v-col>
                          <v-card-actions style="padding: 20px 10px !important;">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                            <button
                                class="button button__danger ml-3"
                                ref="activator"
                                type="button"
                                style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                                @click="deleteRelationSubmit"
                            >
                              Удалить
                            </button>
                          </v-card-actions>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCard"
                  persistent
                  max-width="600px"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCard = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 70px;">
                    <v-container>
                      <v-form ref="form" @submit.prevent="addCard">
                        <div class="text-center">
                          <h3 class="text-center">Добавить новую карту</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="8"
                          >
                            <v-text-field
                                v-model="card_number"
                                :rules="cardNumberRules"
                                label="Номер карты"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;margin-top: 10px"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="4"
                          >
                            <button
                                class="button button__success purpure-button"
                                ref="activator"
                                type="button"
                                style="padding: 8px 20px !important; font-weight: 700;"
                                @click="searchBracelet"
                            >
                              Сгенерировать
                            </button>
                          </v-col>

                          <button
                              class="button button__secondary"
                              ref="activator"
                              type="submit"
                              style="margin:auto; font-weight: 700;"
                          >
                            Сохранить
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center" v-if="card">
              <v-dialog
                  v-model="dialogCardEdit"
                  persistent
                  max-width="600px"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCardEdit = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 70px;">
                    <v-container>
                      <div class="text-center">
                        <h3 class="text-center">Данные по карте</h3>
                      </div>
                      <v-row
                          align="center"
                          class="mt-5 d-flex flex-column justify-center"
                      >
                        <v-col cols="6" style="padding: 0!important;">
                          <v-text-field
                              v-model="chosenCard.card_number"
                              label="Номер карты"
                              class="rounded-lg"
                              outlined
                              dense
                              readonly
                              style="height: 48px;margin-top: 10px"
                              value="SGH124197915"
                          ></v-text-field>
                        </v-col>
                        <span class="card-edit__subtitle">Приложите карту к считывателю</span>
                        <button
                            :class="chosenCard.card_status === 2 ? 'button button__success' : 'button button__danger'"
                            ref="activator"
                            type="button"
                            @click="chosenCard.card_status === 2 ? unlock(chosenCard.card_id) : block(chosenCard.card_id)"
                            style="margin:auto; font-weight: 700;"
                        >
                          {{ chosenCard.card_status === 2 ? 'Разблокировать' : 'Заблокировать' }}
                        </button>
                      </v-row>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogPayment"
                  persistent
                  max-width="540px"
              >

                <v-form
                    ref="formPayment"
                    v-model="validDialogPayment"
                >
                  <v-card rounded="lg">
                    <v-card-title class="justify-space-between">
                      <div></div>
                      <div>
                        <h4>Взнос на лицевой счет</h4>
                      </div>
                      <v-btn icon @click="dialogPayment = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row class="d-flex justify-space-between mt-5">
                          <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                            <span class="payment-text">Чек на</span>
                          </div>
                          <div style="width: 65%">
                            <v-btn-toggle
                                mandatory
                                background-color="white"
                                class="mx-4 rounded-lg"
                                v-model="dialogTypeSender"
                            >
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-phone-incoming-outline
                                </v-icon>
                                Телефон
                              </v-btn>
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-email-outline
                                </v-icon>
                                Эл. почту
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </v-row>

                        <v-btn-toggle
                            v-model="dialogTypeOfPayment"
                            mandatory
                            background-color="#FFFFFF"
                            class="rounded-lg"
                            style="margin-top: 40px; width: 100%"
                        >
                          <v-btn width="50%">
                            Наличные
                          </v-btn>
                          <v-btn width="50%">
                            Карта
                          </v-btn>
                        </v-btn-toggle>
                        <v-row class="mt-5">
                          <v-col cols="12">
                            <label>Касса</label>
                            <v-select
                                v-model="cashbox_debit"
                                :rules="cashboxRules"
                                :items="listCashbox"
                                item-text="legal_entity"
                                item-value="serial"
                                class="rounded-lg"
                                label="Выбрать"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                append-icon="mdi-chevron-down"
                                outlined
                                hide-details
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <label>Л/С</label>
                            <v-select
                                v-model="bill_debit"
                                :rules="mainBillRules"
                                :items="listBill ? listBill.list : []"
                                item-text="deposit_name"
                                item-value="deposit_id"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <label>Сумма взноса</label>
                            <v-text-field
                                v-model="make_summ"
                                :rules="makeSummRules"
                                placeholder="0"
                                outlined
                                dense
                                class="rounded-lg"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <label>Внесено</label>
                            <v-text-field
                                v-model="summ_contributed"
                                :rules="makeSummRules"
                                placeholder="0"
                                outlined
                                dense
                                class="rounded-lg"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <label>Сдача</label>
                            <v-text-field
                                v-model="odd_money"
                                outlined
                                disabled
                                dense
                                class="rounded-lg"
                                background-color="#F1F1F1"
                                color="#629F33"
                            >
                              <template v-slot:append>
                                <span style="padding-top: 4px; color: rgba(98, 159, 51, 1)">₽</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn
                                class="button button__success"
                                style="width: 100% !important; height: 48px !important;"
                                type="button"
                                @click="submitFormMakePayment"
                                :disabled="isLoadingCashbox || isLoadingAccount"
                            >
                              Внести
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
            
            <v-row justify="center">
              <v-dialog
                  v-model="dialogPersonalManager" 
                  persistent
                  max-width="540px"
              >
              <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Смена менеджера</h4>
                    </div>
                    <v-btn icon @click="dialogPersonalManager = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <h3>Список менеджеров:</h3>
                      <v-select
                                v-model="client_new_manager"
                                :items="managersList.managers ?? listClientManagers"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>

                            <v-row v-if="client_new_manager">
                          <v-col>
                            <v-btn
                                class="button button__success"
                                style="width: 100% !important; height: 48px !important;"
                                @click="updateClient()"
                            >
                              Изменить
                            </v-btn>
                            <v-btn
                                class="button button__danger"
                                @click="dialogPersonalManager = false"
                                style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                            >
                              Отмена 
                            </v-btn>
                          </v-col>
                        </v-row>
                    </v-container>
                      </v-card-text>
                  </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogPersonalPlatform" 
                  persistent
                  max-width="540px"
              >
              <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Смена канала продаж:</h4>
                    </div>
                    <v-btn icon @click="advertising_platform_new = null, dialogPersonalPlatform = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <h3>Список каналов:</h3>
                      <v-select
                      v-if="listPlatforms"
                          v-model="advertising_platform_new"
                          class="rounded-lg custom__select"
                          :items="listPlatforms.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Канал привлечения"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          return-object
                          style="height: 48px;"
                      >
                      </v-select>
                      <v-row v-if="advertising_platform_new">
                          <v-col>
                            <v-btn
                                class="button button__success"
                                style="width: 100% !important; height: 48px !important;"
                                @click="updateClient()"
                            >
                              Изменить
                            </v-btn>
                            <v-btn
                                class="button button__danger"
                                @click="advertising_platform_new = null, dialogPersonalPlatform = false"
                                style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                            >
                              Отмена 
                            </v-btn>
                          </v-col>
                        </v-row>
                    </v-container>
                      </v-card-text>
                  </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogPersonalSource"
                  persistent
                  max-width="540px"
              >
              <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Смена источника продаж:</h4>
                    </div>
                    <v-btn icon @click="advertising_source_new = null, dialogPersonalSource = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <h3>Список:</h3>
                      <v-select
                      v-if="listSources"
                          v-model="advertising_source_new"
                          class="rounded-lg custom__select"
                          :items="listSources.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Источник продаж"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          return-object
                          style="height: 48px;"
                      >
                      </v-select>
                      <v-row v-if="advertising_source_new">
                          <v-col>
                            <div v-if="advertising_source_new.name === 'Член клуба'" class="d-flex" style="margin-bottom:20px;">
                              <v-autocomplete
                                  colspan="1"
                                  :items="listClient ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск клиентов"
                                  no-data-text="Результатов не найдено"
                                  clearable
                                  color="#629F33"
                                  item-color="success"
                                  :search-input.sync="search"
                                  v-model="select"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                                  :no-filter=true
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                                  style="height: 30px;margin-top: 10px"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>
                              </v-autocomplete>
                              <v-btn v-show="select !== null" @click="goToClient(select)"
                                     class="button__lighten-success ml-3"
                                     style="height: 40px !important;margin-top: 10px !important;">
                                <span>Карта клиента</span>
                              </v-btn>
                            </div>
                            <v-btn
                                class="button button__success"
                                style="width: 100% !important; height: 48px !important;"
                                @click="updateClient()"
                            >
                              Изменить
                            </v-btn>
                            <v-btn
                                class="button button__danger"
                                @click="advertising_source_new = null, dialogPersonalSource = false"
                                style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                            >
                              Отмена 
                            </v-btn>
                          </v-col>
                        </v-row>
                    </v-container>
                      </v-card-text>
                  </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogDebitPayment"
                  persistent
                  max-width="540px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Оплата</h4>
                    </div>
                    <v-btn icon @click="dialogDebitPayment = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="creditsForm" @submit.prevent="makePayment">
                        <v-row class="d-flex justify-space-between mt-5">
                          <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                            <span class="payment-text">Чек на</span>
                          </div>
                          <div style="width: 65%">
                            <v-btn-toggle
                                v-model="check_to"
                                mandatory
                                background-color="white"
                                class="mx-4 rounded-lg"
                            >
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-phone-incoming-outline
                                </v-icon>
                                Телефон
                              </v-btn>
                              <v-btn>
                                <v-icon
                                    small
                                    dark
                                    class="mr-2"
                                >
                                  mdi-email-outline
                                </v-icon>
                                Эл. почту
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </v-row>
                        <v-btn-toggle
                            v-model="dialogDebitTypeOfPayment"
                            mandatory
                            background-color="#FFFFFF"
                            class="rounded-lg"
                            style="margin-top: 40px; width: 100%"
                        >
                          <v-btn width="25%">
                            Наличные
                          </v-btn>
                          <v-btn width="25%">
                            Л/C
                          </v-btn>
                          <v-btn width="25%">
                            Карта
                          </v-btn>
                          <v-btn width="25%">
                            Бонусы
                          </v-btn>
                        </v-btn-toggle>
                        <v-row class="mt-5">
                          <v-col cols="12">
                            <label>Касса</label>
                            <v-select
                                v-model="cashbox"
                                :rules="cashboxRules"
                                :items="listCashbox"
                                no-data-text="Нет доступных касс"
                                item-text="legal_entity"
                                item-value="serial"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="dialogDebitTypeOfPayment === 1" class="mt-1">
                          <v-col cols="12">
                            <label>Л/С</label>
                            <v-select
                                v-model="main_bill_debit"
                                :rules="mainBillDebtRules"
                                :items="listBill ? listBill.list : []"
                                item-text="deposit_name"
                                return-object
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-tabs-items v-model="dialogDebitTypeOfPayment" class="mt-5">
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    type="number"
                                    outlined
                                    disabled
                                    dense
                                    class="rounded-lg"
                                    background-color="#F1F1F1"
                                    color="success"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                  v-if="main_bill_debit"
                              >
                                <label>Л/C</label>
                                <v-text-field
                                    v-model="main_bill_debit.deposit_balance"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                    color="#629F33"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-row>
                              <v-col>
                                <label>К оплате</label>
                                <v-text-field
                                    v-model="chosenAmountDebt"
                                    outlined
                                    disabled
                                    dense
                                    background-color="#F1F1F1"
                                    class="rounded-lg"
                                >
                                  <template v-slot:append>
                                    <span style="padding-top: 4px">₽</span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                        </v-tabs-items>
                        <v-row>
                          <v-col>
                            <v-btn
                                v-if="!isLoading2"
                                class="button button__success"
                                type="submit"
                                style="width: 100% !important; height: 48px !important;"
                                :disabled="isLoadingCashbox || doingPayment"
                            >
                              Оплатить
                            </v-btn>
                            <v-btn
                                class="button button__danger"
                                @click="cancelReceipt"
                                style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                                :disabled="!doingPayment"
                            >
                              Отмена операции
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogTask"
                  max-width="900px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Новая задача</h4>
                    </div>
                    <v-btn icon @click="dialogTask = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="addTaskForm" @submit.prevent="addTaskSubmit">
                        <v-row
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                          >
                            <label>Сделка</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="newTask.deal"
                                :items="visitorDesktop.client.activeDeals"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                              v-if="listTask"
                          >
                            <label>Вид задачи</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="newTask.type"
                                :items="listTask.monitor"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Тема задачи</label>
                            <v-text-field
                                v-model="newTask.topic"
                                placeholder="Тема задачи"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Описание</label>
                            <v-textarea
                                v-model="newTask.message"
                                placeholder="Описание"
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                              cols="12"
                              md="1"
                              class="d-flex align-center justify-center"
                          >
                            <v-icon
                                large
                                class="mr-2"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-col>
                          <v-col
                              cols="8"
                              md="5"
                          >
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="newTask.date"
                                placeholder="Выбрать"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker"
                                    ref="activator"
                                    type="button"
                                >

                                  <div>
                                    <span v-if="date">{{ date }}</span>
                                    <span v-else style="color: gray">Дата</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        small
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                            </VueDatePicker>
                          </v-col>

                          <v-col
                              cols="4"
                              md="5"
                          >
                              <div style="display:flex; align-items:center;">
                                <v-select
                                      class="rounded-lg custom__select"
                                      v-model="newTask.time"
                                      :items="timeArray"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      placeholder="Время"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      style="height: 48px; margin-top:10px; width:120px; margin-right:10px;"
                                  ></v-select>


                                  <div v-if="newTask.notification_status === 0" 
                                  @click="newTask.notification_status = 1"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer; border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt=""> 
                                  <span style="margin-left:10px;">Не напоминать </span>
                                  </div>
                                  <div v-else 
                                  @click="newTask.notification_status = 0"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer;  border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt="">  
                                  <span style="margin-left:10px;">В момент события</span>
                                  </div>

                              </div>
                          </v-col>

                        </v-row>
                          
                        <v-row>

                            <v-col
                                cols="9"
                                md="9"
                            >
                            <div style="display:flex; align-items:center;">
                              <div style="display:flex; align-items:center; justify-content:center; padding:4px;">
                                <img src="/playground_assets/mediumuseri324-pp8g.svg" style="width: 30px;" alt="">
                              </div>
                                <v-select
                                              class="rounded-lg custom__select"
                                              v-model="newTask.specialist_id.id"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px;  margin-left:35px;">
                                </v-select>

                                <div style="width:250px; font-size:16px; margin-left:20px;">
                                  Создана: {{ new Date().toISOString().split('T')[0] }}
                                </div>
                            </div>
                            </v-col>
                        </v-row>

                        <v-row>
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                              style="margin-left: auto;font-weight: 700; height:116px; height:48px;"
                          >
                            Сохранить
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogEditTask"
                  max-width="900px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>{{ editTask.topic }}</h4>
                    </div>
                    <v-btn icon @click="dialogEditTask = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="editTaskForm" @submit.prevent="editTaskSubmit">
                        <v-row
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                              v-if="editTask.deal && editTask.deal.length > 0"
                          >
                            <label>Сделка</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="editTask.deal"
                                :items="visitorDesktop.client.activeDeals"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                              v-if="listTask"
                          >
                            <label>Вид задачи</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="editTask.type_id"
                                :items="listTask.monitor"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Тема задачи</label>
                            <v-text-field
                                v-model="editTask.topic"
                                placeholder="Тема задачи"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Описание</label>
                            <v-textarea
                                v-model="editTask.description"
                                placeholder="Описание"
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                              cols="12"
                              md="1"
                              class="d-flex align-center justify-center"
                          >
                            <v-icon
                                large
                                class="mr-2"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-col>
                          <v-col
                              cols="8"
                              md="5"
                          >
                          <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="editTask.assigned_to"
                                placeholder="Выбрать"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker"
                                    ref="activator"
                                    type="button"
                                >

                                  <div>
                                    <span v-if="editTask.assigned_to">{{ formatDateTime2(editTask.assigned_to) }}</span>
                                    <span v-else style="color: gray">Дата{{date}}</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                            </VueDatePicker>
                          </v-col>

                          <v-col
                              cols="4"
                              md="5"
                          >
                              <div style="display:flex; align-items:center;">
                                <v-select
                                      class="rounded-lg custom__select"
                                      v-model="editTask.time"
                                      :items="timeArray"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      placeholder="Время"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      style="height: 48px; margin-top:10px; width:120px; margin-right:10px;"
                                  ></v-select>


                                  <div v-if="editTask.notification_status === 0" 
                                  @click="editTask.notification_status = 1"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer; border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt=""> 
                                  <span style="margin-left:10px;">Не напоминать </span>
                                  </div>
                                  <div v-else 
                                  @click="editTask.notification_status = 0"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer;  border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt="">  
                                  <span style="margin-left:10px;">В момент события</span>
                                  </div>

                              </div>
                          </v-col>

                        </v-row>
                          
                        <v-row>

                            <v-col
                                cols="9"
                                md="9"
                            >
                            <div style="display:flex; align-items:center;">
                              <div style="display:flex; align-items:center; justify-content:center; padding:4px;">
                                <img src="/playground_assets/mediumuseri324-pp8g.svg" style="width: 30px;" alt="">
                              </div>
                                <v-select
                                v-if="editTask.user"
                                              class="rounded-lg custom__select"
                                              v-model="editTask.user.id"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px;  margin-left:35px;">
                                </v-select>
                                <v-select
                                v-else
                                              class="rounded-lg custom__select"
                                              v-model="editTask.specialist_id.id"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px;  margin-left:35px;">
                                </v-select>

                                <div style="width:250px; font-size:16px; margin-left:20px;">
                                  Создана: {{ editTask.date_create ? editTask.date_create : '' }}
                                </div>
                            </div>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                          <v-col
                              cols="12"
                              md="1"
                              class="d-flex align-center justify-center"
                          >
                            <v-icon
                                large
                                class="mr-2"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-col>
                          <v-col
                              cols="12"
                              md="5"
                          >
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="editTask.assigned_to"
                                placeholder="Выбрать"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker"
                                    ref="activator"
                                    type="button"
                                >

                                  <div>
                                    <span v-if="editTask.assigned_to">{{ formatDateTime(editTask.assigned_to) }}</span>
                                    <span v-else style="color: gray">Дата{{date}}</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                            </VueDatePicker>
                          </v-col>
  
                        </v-row> -->
                
                        <v-row>
                          <div style="margin-left: auto;">
                            <button
                                class="button button__danger mr-3"
                                type="button"
                                style="font-weight: 700; border-radius: 12px !important;"
                                @click="deleteTask(editTask.id)"

                            >
                              Удалить
                            </button>
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                                style="font-weight: 700;"
                            >
                              Сохранить
                            </button>
                          </div>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <!-- <v-row justify="center">
              <v-dialog
                  v-model="dialogNote"
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Новая заметка</h4>
                    </div>
                    <v-btn icon @click="dialogNote = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="addNoteForm" @submit.prevent="addNote">
                        <v-row
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Текст заметки</label>
                            <v-textarea
                                v-model="newNote.note"
                                :rules="noteRules"
                                placeholder="Написать..."
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                              style="margin-left: auto;font-weight: 700;"
                          >
                            Сохранить
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row> -->
            <v-row justify="center">
              <v-dialog
                  v-model="dialogEditNote"
                  max-width="600px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Новая заметка</h4>
                    </div>
                    <v-btn icon @click="dialogEditNote = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="editNoteForm" @submit.prevent="editNoteSubmit">
                        <v-row
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Текст заметки</label>
                            <v-textarea
                                v-model="editNote.note"
                                :rules="noteRules"
                                placeholder="Написать..."
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                              style="margin-left: auto;font-weight: 700;"
                          >
                            Сохранить
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCreateDeal"
                  persistent
                  max-width="400px"
              >
                <v-card>
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>{{ type ?? 'Новая сделка' }}</h4>
                    </div>
                    <v-btn icon @click="dialogCreateDeal = false" >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-top: 50px; padding-bottom: 30px;">
                    <v-container>
                      <template v-if="listDeals.length > 1">
                        <button
                            v-for="item in listDeals"
                            :key="item.id"
                            class="button button__lighten"
                            style="width: 100% !important; margin-top: 20px !important;"
                            @click="createDeal(item.id, item.stages[0].id)"
                        >
                          {{ item.name }}
                        </button>
                      </template>
                      <template v-else>
                        <span v-if="dealProcess">Обработка...</span>
                        <button
                            class="button button__lighten"
                            style="width: 100% !important;"
                            @click="listDeal('Продажа')"
                        >
                          Продажа
                        </button>
                        <button
                            class="button button__lighten"
                            style="width: 100% !important; margin-top: 20px !important;"
                            @click="listDeal('Продление')"
                        >
                          Продление
                        </button>
                      </template>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogActiveStage"
                  persistent
                  max-width="350px"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogActiveStage = false" >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 30px;">
                    <v-container>
                      <div>
                        <h3 class="card-title text-center">Подтвердить действие?</h3>
                      </div>
                      <v-row
                          align="center"
                          class="justify-center"
                          style="padding: 50px 0;"
                      >
                        <v-btn
                            class="button button__success"
                            :disabled="isLoadingDeals || isLoading"
                            @click="updateStage"
                        >
                          Да
                        </v-btn>
                        <v-btn
                            class="button button__lighten ml-5"
                            type="button"
                            @click="dialogActiveStage = false"
                        >
                          Нет
                        </v-btn>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogSuccessStage"
                  persistent
                  max-width="500px"
              >
                <v-card>
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>{{ deal_name }}</h4>
                    </div>
                    <v-btn icon @click="dialogSuccessStage = false" >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-top: 50px; padding-bottom: 30px;">
                    <v-container>
                      <v-btn
                          :to="{ name: 'Sale', params: {client: visitorDesktop.client, buy_id: null, type: 'new', for: 'deal', deal: this.deal_id} }"
                          class="button button__lighten"
                          style="width: 100% !important;"
                      >
                        Создать продажу
                      </v-btn>
                      <v-btn
                          :to="{ name: 'SalesNodeal', params: {client: visitorDesktop.client, deal: this.deal_id} }"
                          class="button button__lighten"
                          style="width: 100% !important; margin-top: 20px !important;"
                      >
                        Выбрать продажу
                      </v-btn>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCancelStage"
                  persistent
                  max-width="600px"
                  v-if="failureTypes"
              >
                <v-card>
                  <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCancelStage = false" >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding-bottom: 30px;">
                    <v-container>
                      <div class="text-center">
                        <h3 class="text-center">Выберите причину отказа</h3>
                      </div>
                      <v-form ref="cancelDealForm" @submit.prevent="updateFailure">
                        <v-row
                            align="center"
                            class="mt-5 d-flex flex-column justify-center"
                        >
                          <v-col cols="6" style="padding: 0!important;">
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="select_cancelDeal"
                                :items="failureTypes.deals"
                                item-value="id"
                                item-text="name"
                                :rules="[v => !!v || 'Выберите причину отказа']"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Причина"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                              style="margin:auto; font-weight: 700; margin-top: 30px !important;"
                          >
                            Выбрать
                          </button>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogTag"
                  max-width="800px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Выбор тегов</h4>
                    </div>
                    <v-btn icon @click="dialogTag = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container>
                      <div class="d-flex justify-content-between align-center" style="padding: 20px ">
                        <div v-if="dialogTypeOfTags === 0">
                          <!-- <v-autocomplete
                              ref="tagSearch"
                              colspan="1"
                              placeholder="Поиск тегов"
                              color="#629F33"
                              item-color="success"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                              :no-filter=true
                              :search-input.sync="searchTagValue"
                              v-model="newtag_search"
                              class="rounded-lg"
                              append-icon=""
                              hide-details
                              hide-no-data
                              outlined
                              dense
                              required
                              background-color="white"
                              style="height: 40px;"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon>mdi-magnify</v-icon>
                            </template>
                          </v-autocomplete> -->

                          <v-text-field
                                  v-model="newtag_search"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px; width:200px; margin-left:10px;"
                                  class="rounded-lg"
                                  @keyup="keyUpTags"
                              >
                              <template v-slot:prepend-inner>
                              <v-icon>mdi-magnify</v-icon>
                            </template>
                            </v-text-field>

                        </div>
                        <div class="ml-5">
                          <v-btn-toggle
                              v-model="dialogTypeOfTags"
                              mandatory
                              background-color="#FFFFFF"
                              class="rounded-lg"
                              style="width: 100%"
                          >
                            <v-btn width="50%">
                              Все
                            </v-btn>
                            <v-btn width="50%">
                              Выбранные
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                      </div>
                      <div>
                        <v-data-table
                            v-if="listTags && dialogTypeOfTags === 0"
                            :headers="headersTags"
                            :items="listTags.tags"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
                            hide-default-footer
                            disable-pagination
                            show-select
                            class="elevation-1"
                        >
                        </v-data-table>
                        <v-data-table
                            v-else-if="listTags && dialogTypeOfTags === 1"
                            :headers="headersTagsChosed"
                            :items="listTagsChosed"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
                            hide-default-footer
                            disable-pagination
                            show-select
                            class="elevation-1"
                        >
                        </v-data-table>
                      </div>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-content-between">
                    <v-btn
                        @click="dialogAddTag = true"
                        class="button__lighten"
                    >
                      <v-icon small class="mr-2">mdi-plus</v-icon>
                      Создать
                    </v-btn>
                    <v-btn
                        color="#629F33"
                        class="button__success"
                        @click="addTagSubmit"
                    >
                      Сохранить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogAddTag"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Теги (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogAddTag = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="tagAddForm" @submit.prevent="submitTag">
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="tag.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogDepositHistory"
                  max-width="800px"
              >
                <v-card rounded="lg" v-if="depositHistory">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4 v-if="depositHistory">{{ depositHistory.name }}</h4>
                    </div>
                    <v-btn icon @click="dialogDepositHistory = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="padding-left: 0px !important; padding-right: 0px !important;">
                      <div class="d-flex justify-content-between align-center" style="padding: 20px; height:36px; border-top:1px solid #E0E0E0; font-size:18px;">
                        <div>
                          Владелец
                        </div>
                        <div style="color:#000; margin-left:30px;">
                          <b>{{visitorDesktop.client.name}}</b>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between align-center" style="padding: 20px; height:36px; background-color:#F1F1F1; width: 100%; color:#000; font-size:16px;">
                        <div style="width: 80%;">
                          <b>Остаток</b>
                        </div>
                        <div>
                          <b>{{depositHistory.balance}}</b>
                        </div>
                      </div>
                      <div>
                        <v-data-table
                            v-if="depositHistoryList"
                            :headers="headersDepositHistory"
                            :items="depositHistoryList.history"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
                            hide-default-footer
                            hide-default-header
                            disable-pagination
                            class="elevation-1"
                        >
                        <template v-slot:item.date="{ item }">
                          {{ item.date.split('T')[0].split('-')[2] + '.' + item.date.split('T')[0].split('-')[1] + '.' + item.date.split('T')[0].split('-')[0] + ' ' + item.date.split('T')[1] }}
                        </template>
                        </v-data-table>
              
                      </div>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogCardHistory"
                  max-width="800px"
              >
                <v-card rounded="lg" v-if="dialogCardHistory">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>

                      <h4> Исотрия изменений карточки</h4>

                    </div>
                    <v-btn icon @click="dialogCardHistory = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="padding-left: 0px !important; padding-right: 0px !important;">
          
                      <div>
                        <v-data-table
                            v-if="historyCardList"
                            :headers="headersCardHistory"
                            :items="historyCardList.history"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
               
                            class="elevation-1"
                        >
                        </v-data-table>
                     
                      </div>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogDeleteNote"
                  persistent
                  max-width="400px"
              >
                <v-form @submit.prevent="deleteNoteSubmit">
                  <v-card>
                    <v-card-title class="text-center">
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialogDeleteNote = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 30px;">
                      <v-container>
                        <div>
                          <h3 class="card-title">Вы уверены, что хотите удалить заметку?</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5 justify-center"
                        >
                          <button
                              class="button button__danger"
                              ref="activator"
                              type="submit"
                          >
                            Да
                          </button>
                          <button
                              class="button button__unlock ml-5"
                              ref="activator"
                              type="button"
                              @click="dialogDeleteNote = false"
                          >
                            Нет
                          </button>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>

                       <!-- Enter Modal -->
        <v-row justify="center">
          <v-dialog
              v-model="dialogNote"
              persistent
              max-width="540px"
          >
          <v-card rounded="lg" >
     
            <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4 style="font-weight:bold;">Новая заметка</h4>
                </div>
                <v-btn icon @click="dialogNote = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>

                <v-card-text>
                  <v-container>
                      <div >
                        <v-textarea
                            v-model="noteNew"
                            :rules="noteRules"
                            rounded
                            outlined
                            dense
                            required
                            auto-grow
                            background-color="#fff"
                            rows="5"
                            style="width: 100%; height: 150px"
                        ></v-textarea>

              
                      </div>
                      <v-row>
                        <v-col style="text-align:end;">
                          <v-btn
                              class="button button__success"
                              style="font-size: 13px; font-weight: 700; padding: 8px 20px !important; align-content: center"
                              @click="noteNewAdd"
                          >
                            Добавить
                          </v-btn>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-card-text>

          </v-card>
          </v-dialog>
         </v-row>

          </v-container>
          <v-container class="col-10" style="display:flex; flex-direction:column; align-items:center; justify-content: center; padding-top:300px;" v-else>
            <v-row><h3>Загрузка данных</h3></v-row>
            <v-row>
            <v-progress-circular
              color="green"
              indeterminate
              style="width:200px; height:200px;"
            ></v-progress-circular>
          </v-row>
          </v-container>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {globalMethods} from "@/mixins/globalMethods";
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import Icon from '@/components/Icons.vue';
import {mapState} from "vuex";
import {clientActionTypes} from '@/store/modules/client';
import {receptionActionTypes} from '@/store/modules/reception';
import {relativesActionTypes} from '@/store/modules/relatives';
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {monitorActionTypes} from "@/store/modules/monitor";
import {billActionTypes} from "@/store/modules/bill";
import {tasksActionTypes} from "@/store/modules/tasks";
import {notesActionTypes} from "@/store/modules/notes";
import {dealsActionTypes} from "@/store/modules/deals";
import {accountActionTypes} from '@/store/modules/account';
import {tagsActionTypes} from '@/store/modules/tags';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {uisActionTypes} from '@/store/modules/uis';
import {advertisingActionTypes} from "@/store/modules/advertising";
import {organizationActionTypes} from '@/store/modules/organization';
import {lessonActionTypes} from "@/store/modules/lesson";

export default {
  name: 'CardClientNew',
  props: ['client_id'],
  mixins: [globalMethods],
  components: {
    VueDatePicker,
    Header,
    Menu,
    Icon
  },
  data() {
    return {
      dialogDepositHistory:false,
      depositHistory:null,
      dealProcess:false,
      dialogPersonalManager:false,
      deal_id: null,
      stage_id: null,
      deal_name: null,
      select_cancelDeal: null,
      activeStageIndex: 0,
      counterInterval: null,
      tab: null,
      date_birthday: new Date(),
      exitButtonText: "",
      date: new Date(),
      dateRules: [
        v => !!v || 'Дата рождения обязательное поле'
      ],
      valid: true,
      validDialogPayment: true,
      first_name: '',
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      middle_name: '',
      middleNameRules: [
        v => !!v || 'Фамилия обязательное поле'
      ],
      last_name: '',
      lastNameRules: [
        v => !!v || 'Отчество обязательное поле'
      ],
      gender: '',
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      genderTypes: [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      email: '',
      emailRules: [
        v => !!v || 'Электронная почта обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      relative_type: '',
      relativeTypeRules: [
        v => !!v || 'Степень родства обязательное поле'
      ],
      is_representative: false,
      main_bill: '',
      bill_debit: null,
      mainBillRules: [
        v => !!v || 'Лицевой счет обязательное поле'
      ],
      bonus_bill: '',
      bonusBillRules: [
        v => !!v || 'Бонусный счет обязательное поле'
      ],
      billTypes: [
        {type_id: 1, type_name: 'Общий'},
        {type_id: 2, type_name: 'Раздельный'},
      ],
      select: null,
      selectTag: [],
      selectRules: [
        v => !!v || 'Нужно выбрать родственника'
      ],
      card_number: null,
      cardNumberRules: [
        v => !!v || 'Номер карты обязательное поле'
      ],
      note: null,
      noteRules: [
        v => !!v || 'Заметки обязательное поле'
      ],
      makeSummRules: [
        v => !!v || 'Сумма обязательная'
      ],
      main_bill_debit: null,
      mainBillDebtRules: [
        v => !!v || 'Нужно выбрать Л/С',
        v => v?.deposit_balance >= this.chosenAmountDebt || 'Сумма Л/С должна быть больше суммы к оплате'
      ],
      cashbox_debit: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      newTask: {
        deal: null,
        type: null,
        topic: null,
        message: null,
        date: null,
        time: null,
        notification: false,
        manager: null,
        time:null,
        specialist_id:{
          id:getItem('user_id_1c'),
          name:getItem('fio')
        },
        notification_status:0
      },
      newNote: {
        note: null
      },
      editTask: {
        id: null,
        deal: null,
        type: null,
        topic: null,
        message: null,
        date: null,
        time: null,
        notification: false,
        manager: null,
        description:null,
        time:null,
        specialist_id:{
          id:getItem('user_id_1c'),
          name:getItem('fio')
        },
        notification_status:0,
        date_create:null,
        type_id:null
      },
      tag: {
        name: null
      },
      chosenCard: null,
      unsetClient: true,
      isLoading2: false,
      dialog: false,
      dialogCard: false,
      dialogCardEdit: false,
      dialogRelationEdit: false,
      dialogPayment: false,
      dialogDebitPayment: false,
      dialogTask: false,
      dialogEditTask: false,
      dialogNote: false,
      dialogEditNote: false,
      dialogTag: false,
      dialogAddTag: false,
      dialogCreateDeal: false,
      dialogSuccessStage: false,
      dialogCancelStage: false,
      dialogActiveStage: false,
      check_to: 0,
      dialogDebitTypeOfPayment: null,
      dialogDeleteNote: false,
      deleteNoteId: null,
      editRelationItems: {
        id: null,
        name: '',
        relative_type: '',
        main_bill: '',
        bonus_bill: '',
        is_representative: false,
      },
      dialogTypeOfPayment: 0,
      dialogTypeSender: 0,
      dialogTypeOfTags: 0,
      client_new_manager:null,
      listClientManagers:[
      {name: 'Менеджер 1',id: 1},
      {name: 'Менеджер 2',id: 2}
      ],
      items: [
        {tab: 'CRM'},
        {tab: 'Членства (Пакеты услуг)'},
        {tab: 'Закрытые сделки'},
      ],
      headersSubscribe: [
        {text: 'Членства и пакет', align: 'start', sortable: false, value: 'product_name', width: '50%'},
        {text: 'Активирован', value: 'product_activationdate', width: '15%'},
        {text: 'Активен по', value: 'product_lastdate', width: '10%'},
        {text: 'Статус', value: 'status_description', width: '20%'},
        {text: 'Действия', value: 'actions', sortable: false, width: '5%'},
      ],
      headersService: [
        {text: 'Услуга', align: 'start', sortable: false, value: 'service_name', width: '75%'},
        {text: 'Остаток', value: 'service_balance', width: '20%'},
        {text: 'Действия', value: 'actions', sortable: false, width: '5%'},
      ],
      headersDeals: [
        {text: 'Сделки', align: 'start', sortable: false, value: 'name', width: '75%'},
        {text: 'Дата закрытия', value: 'date_end', width: '20%'},
        {text: 'Статус', value: 'result', sortable: false, width: '5%'},
      ],
      search: '',
      headersCredit: [
        {text: 'Услуги, товары', align: 'start', sortable: false, value: 'buy.buy_name'},
        {text: 'Сумма', value: 'amount_debt', width: '20%'}
      ],
      headersTags: [
        {text: 'Теги', align: 'start', sortable: false, value: 'name'}
      ],
      headersTagsChosed: [
        {text: 'Теги', align: 'start', sortable: false, value: 'name'}
      ],
      headersDepositHistory:[
        {text: '', align: 'start', sortable: false, value: 'date'},
        {text: '', align: 'start', sortable: false, value: 'type'},
        {text: '', align: 'start', sortable: false, value: 'summ'}
      ],
      headersCardHistory:[
        {text: 'Дата', align: 'start', sortable: false, value: 'date'},
        {text: 'Сотрудник', align: 'start', sortable: false, value: 'user.name'},
        {text: 'История', align: 'start', sortable: false, value: 'comment'}
      ],
      type: null,
      listDeals: [],
      credits: [],
      make_summ: null,
      summ_contributed: null,
      odd_money: 0,
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      dialogPersonalPlatform:null,
      dialogPersonalSource:null,
      advertising_platform_new:null,
      advertising_source_new:null,
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      taskchecked:false,
      listTagsChosed:[],
      dateDef: new Date(),
      timeArray: [
        '00:00','00:30','01:00','01:30',
        '02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00','06:30',
        '07:00','07:30','08:00','08:30','09:00','09:30','10:00','10:30','11:00','11:30',
        '12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30',
        '17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00',
        '22:30','23:00','23:30'
      ],
      dialogCardHistory:false,
      searchTagValue:'',
      listTagsDef:[],
      listTagsChosedDef:[],
      editNoteStatus: false,
      editNoteId: null,
      noteNew:'',
      noteNewType:1,
      newtag_search:null,
      needSave:false,
      cardHistoryLoading:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.reception.isLoading,
      isLoadingCashbox: state => state.cashbox.isLoading,
      isLoadingAccount: state => state.account.isLoading,
      isLoadingDeals: state => state.deals.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      listClient: state => state.client.listClient,
      listRelativesTypes: state => state.relatives.listRelativesTypes,
      failureTypes: state => state.deals.failureTypes,
      card: state => state.client.card,
      listBill: state => state.bill.list,
      listTask: state => state.monitor.listTask,
      listTags: state => state.tags.data,
      visitorDesktop: state => state.reception.visitorDesktop,
      validationErrors: state => state.reception.validationErrors,
      listPlatforms: state => state.advertising.listPlatforms,
      listSources: state => state.advertising.listSources,
      managersList: state => state.organization.managersList,
      specialist: state => state.lesson.specialist,
      depositHistoryList: state => state.bill.historyList,
      historyCardList: state => state.client.cardHistory,
      listNotes: state => state.notes.listNotes
    }),
    chosenAmountDebt() {
      let total = 0;
      for (let debt of this.credits) {
        total += debt.amount_debt;
      }
      return total
    },
    totalAmountDebt() {
      let total = 0;
      for (let debt of this.visitorDesktop.client.debts) {
        total += debt.amount_debt;
      }
      return total
    }
  },
  mounted() {

    console.log(this.$route.query)

    if(this.$route.query && this.$route.query.clientid){
      this.client_id = this.$route.query.clientid
    }

    this.client_id !== undefined ? setItem('sale_card-client_id', this.client_id) : this.client_id = getItem('sale_card-client_id');
    if(getItem('client-parent-2') && getItem('client-parent-2') !== undefined && getItem('client-parent-2') !== null && getItem('client-parent-2') !== 'null'){
      console.log(getItem('client-parent-2'))
      this.client_id = getItem('client-parent-2')
      setItem('client-parent-2',null)
    }
    this.fetchFeed(this.client_id)
    this.$store.dispatch(advertisingActionTypes.getPlatforms)
    this.$store.dispatch(advertisingActionTypes.getSources)
    this.$store.dispatch(organizationActionTypes.organizationManagersList)
    this.$store.dispatch(lessonActionTypes.getSpecialistList);
    this.setCashboxTerminal()
    this.$store.dispatch(notesActionTypes.getNotesList, {
              client_id: this.client_id
            });

            setItem('sale-client',null)
            setItem('sale-buyer_saler',null)
  },
  watch: {
    // searchTagValue: function(value){
    //   // if (value && value !== '' && this.listTags && this.listTags.tags)  {
    //   //   console.log(value)
    //   //   this.listTags.tags = this.listTags.tags.filter((item) => item.name === value);
    //   // }

    //   if(value == "" || !value || value === null){


    //    // setItem('card_tag_search', null);

    //                 this.listTags.tags = this.listTagsDef
    //                 return;
    //             }

    //             //setItem('card_tag_search', value);

    //             //this.newtag_search = value

    //             let obj = []
    //             let obj2 = []
    //             obj = this.listTagsDef                
    //             var self = this
    //             obj2 = obj.filter(function (item) {
    //               if(item && item.name != null){
    //                 return item.name.toString().toLowerCase().indexOf(value.toLowerCase()) >= 0
    //               }
    //             }) 
    //             this.listTags.tags = obj2
    // },
    search: function (value) {
      if (!!value) {
        value = value.trim()
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: value
        })
      }
    },
    summ_contributed: function (value) {
      if (this.make_summ) {
        let odd_money = value - this.make_summ
        if (odd_money > 0) {
          this.odd_money = odd_money
        } else {
          this.odd_money = 0
        }
      }
    },
    dialogCard() {
      if (!this.dialogCard) {
        this.stopCard()
      }
    },
    selectTag() {
      console.log(this.selectTag)
      console.log(this.searchTagValue)

      //if(getItem('card_tag_search') && getItem('card_tag_search') !== null){
          //this.searchTagValue(getItem('card_tag_search'))
          //this.newtag_search = this.searchTagValue
          //console.log(this.$refs.tagSearch)
          //this.$refs.tagSearch.value = getItem('card_tag_search')

          // let obj = []
          //       let obj2 = []
          //       obj = this.listTagsDef                
          //       var self = this
          //       obj2 = obj.filter(function (item) {
          //         if(item && item.name != null){
          //           return item.name.toString().toLowerCase().indexOf(self.searchTagValue.toLowerCase()) >= 0
          //         }
          //       }) 
          //       this.listTags.tags = obj2
      //}
      // for(var u in this.visitorDesktop.client.tags){
      //   if(this.visitorDesktop.client.tags[u].tag_id === this.selectTag[this.selectTag.length-1].id){
      //     alert('Тег уже существует!')
      //     this.selectTag.pop()
      //   }
      // }
      
    },
    dialogTypeOfTags(){
      console.log(this.dialogTypeOfTags)
      if(this.dialogTypeOfTags === 1){
        this.listTagsChosed = []
        for(var u in this.selectTag){
          console.log('gg1')
          this.listTagsChosed.push(this.selectTag[u])
        }
      }
    }
  },
  methods: {
    goToDesktop(client_id){
      setItem('client-parent',this.client_id);
      let rroute = 'CardClientParent'
      this.$router.push({
                  name: rroute,
                  params: {
                    client_id: client_id
                  }
                });
    },  
    keyUpTags(){
      if(this.newtag_search == "" || !this.newtag_search || this.newtag_search === null){


// setItem('card_tag_search', null);

             this.listTags.tags = this.listTagsDef
             return;
         }

         //setItem('card_tag_search', value);

         //this.newtag_search = value

         let obj = []
         let obj2 = []
         obj = this.listTagsDef                
         var self = this
         obj2 = obj.filter(function (item) {
           if(item && item.name != null){
             return item.name.toString().toLowerCase().indexOf(self.newtag_search.toLowerCase()) >= 0
           }
         }) 
         this.listTags.tags = obj2
    },
    refreshClient(client_id){
      this.client_id = client_id
      
      //this.client_id !== undefined ? setItem('sale_card-client_id', this.client_id) : this.client_id = getItem('sale_card-client_id');

      if (this.$route.path === '/card-potential-client') {
        this.$router.push({name: 'CardClientNewOt', params: {client_id: this.client_id}})
      } else {
        this.fetchFeed(this.client_id)
        this.$store.dispatch(advertisingActionTypes.getPlatforms)
        this.$store.dispatch(advertisingActionTypes.getSources)
        this.$store.dispatch(organizationActionTypes.organizationManagersList)
        this.$store.dispatch(lessonActionTypes.getSpecialistList);
      }

    },
    editNote(id, note) {
      this.editNoteStatus = true;
      this.editNoteId = id;
      this.note = note;
    },
    deleteNote(id,type) {
      this.noteNewType = type
      this.deleteNoteId = id;
      this.dialogDeleteNote = true;
    },
    noteNewAdd(){
      if (this.noteNew && this.noteNew.length > 0) {

        //this.noteNew.type = this.noteNewType

          this.$store.dispatch(notesActionTypes.notesAdd, {
            client_id: this.client_id,
            note: this.noteNew,
            type: this.noteNewType
          })
          .then(() => {
            this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
              this.note = '';
              this.noteNew = '';
              this.dialogNote = false

              this.fetchFeed(this.client_id)
          })
      }
    },
    noteSubmit() {
      if (this.$refs.noteForm.validate()) {
        if (this.editNoteStatus === true) {
          this.$store.dispatch(notesActionTypes.notesEdit, {
            client_id: this.client_id,
            note_id: this.editNoteId,
            note: this.note
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
                this.editNoteStatus = false;
              })
        } else {
          this.$store.dispatch(notesActionTypes.notesAdd, {
            client_id: this.client_id,
            note: this.note,
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
              })
        }
      }
    },
    deleteNoteSubmit() {
      this.$store.dispatch(notesActionTypes.notesRemove, {
        client_id: this.client_id,
        note_id: this.deleteNoteId,
        type:this.noteNewType
      })
          .then(() => {
            this.$store.dispatch(notesActionTypes.getNotesList, {
              client_id: this.client_id
            });
            this.dialogDeleteNote = false;
          })
    },
    getCardHistory(){
      this.cardHistoryLoading = true
      this.$store.dispatch(clientActionTypes.getCardHistory, {client:this.client_id})
      .then((response) => {
        if(response && response.success){
          this.dialogCardHistory = true
        } else {
          alert('Проблема при загрузке данных клиента!')
        }
        this.cardHistoryLoading = false
    })
    },
    getDepositItem(item){
      console.log(item)
      this.depositHistory = item
      this.$store.dispatch(billActionTypes.getDepositHistory, {item})
      .then((response) => {
        if(response && response.success){
          this.dialogDepositHistory = true
        } else {
          alert('Проблема при загрузке данных клиента!')
        }})
    },
    makeAlert(){
      alert('Детализация возможна только для успешных сделок!')
    },
    formatDateTime2(date) {
      date = new Date(date);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      // const hours = date.getHours().toString();
      // const minutes = date.getMinutes().toString();

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      date = new Date(date);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      const hours = date.getHours().toString();
      const minutes = date.getMinutes().toString();

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    formatDate(data) {
      
      let date = data.date_end
      let descr = ''

      if(data.date_end.split('T'[1])){
        date = data.date_end.split('T')[0] + ' ' + data.date_end.split('T')[1]
      }

      if(data.description) {
        descr = data.description
      }

      return descr

    },
    setCashboxTerminal(){
      let serial = (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : null
      if (JSON.parse(getItem('select_org-sale'))) {
        let org = JSON.parse(getItem('select_org-sale'));
        serial = org.serial
      }
      if(!this.listCashbox || !this.listCashbox[0]){
        //alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: serial
      }).then((resp) => {
       console.log(resp)
       if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
          this.cashboxTerminal = resp.cashbox.terminals[0].id
       } 
      //  else {
      //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
      //  }
      })
    },
    goToClient(client_id){
      this.$router.push({ name: 'Desktop', params: { client_id: client_id } })
    },
    fetchFeed(client_id) {
      this.isLoading2 = true
      this.client_id = client_id;
      this.$store.dispatch(receptionActionTypes.desktopClientSale, {client_id})
      .then((response) => {
        if(response && response.success){
          this.isLoading2 = false
          //if(this.needSave) {
            //save client search data
            
            this.saveClientSearch(response.client)
         //}
        } else {
          alert('Проблема при загрузке данных клиента!')
           if(client_id){
            this.$store.dispatch(receptionActionTypes.desktopClientSale, {client_id})
              .then((response) => {
                if(response && response.success){
                  this.isLoading2 = false
                }
              })
           }
        }
      })  
    },
    saveClientSearch(client){
      console.log('needsave')
        this.$store.dispatch(clientActionTypes.saveSearchClient, {
          client_id: this.client_id,
          phone: client.phone,
          fio: client.name,
          type:1
        })
          .then((resp) => {
            console.log(resp)
        })
    },
    getRoute(status, product_id) {
      if (status === 'Активен') return {
        name: 'FreezePackage',
        params: {client_id: this.client_id, product_id: product_id}
      }
      else if (status === 'Заморожен') return {
        name: 'UnfreezePackage',
        params: {client_id: this.client_id, product_id: product_id}
      }
      else {
        return {}
      }
    },
    getNameStatus(status) {
      if (status === 'Активен') return 'Заморозить'
      else if (status === 'Заморожен') return 'Разморозить'
      else if (status === 'Продан') return 'Активировать'
      else if (status === 'Закрыт') return 'Закрыт'
    },
    activateProduct(item) {
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: item,
        client_id: this.client_id
      })
          .then((response) => {
            if (response.success)
              this.fetchFeed(this.client_id)
          })
    },
    chooseDeal() {
      this.dialogCreateDeal = true;
    },
    listDeal(type) {
      if(!this.dealProcess){
        this.dealProcess = true
        this.$store.dispatch(monitorActionTypes.getListDeal, {
          type
        })
            .then((response) => {
              this.dealProcess = false
              if (response.success) {
                if (response.monitor.length === 1) {
                  this.$store.dispatch(dealsActionTypes.createDeal, {
                    client_id: this.client_id,
                    deal_id: response.monitor[0].id,
                    stage_id: response.monitor[0].stages[0].id,
                  }).then((response) => {
                    if (response.success) {
                      this.fetchFeed(this.client_id);
                      this.dialogCreateDeal = false;
                    }
                  })
                } else {
                  this.type = type;
                  this.listDeals = response.monitor;
                }
              }
          })
      }
    },
    createDeal(deal_id, stage_id) {
      this.$store.dispatch(dealsActionTypes.createDeal, {
        client_id: this.client_id,
        deal_id,
        stage_id
      }).then((response) => {
        if (response.success) {
          this.listDeals = [];
          this.type = null;
          this.fetchFeed(this.client_id);
          this.dialogCreateDeal = false;
        }
      })
    },
    setActiveStage(deal, stage) {
      
      this.deal_id = deal.id;

      console.log(this.deal_id)
      
      this.stage_id = stage.id;
      this.deal_name = deal.name;
      if (stage.name === 'Успех') this.dialogSuccessStage = true;
      else if (stage.name === 'Отказ') {
        this.$store.dispatch(dealsActionTypes.failureTypes)
            .then((response) => {
              if (response.success)
                this.dialogCancelStage = true;
            });
      }
      else this.dialogActiveStage = true
    },
    updateStage() {
      this.$store.dispatch(dealsActionTypes.updateStage, {
        deal_id: this.deal_id,
        stage_id: this.stage_id
      })
          .then((response) => {
            if (response.success)
              this.fetchFeed(this.client_id)
            this.dialogActiveStage = false
          })
    },
    updateFailure() {
      if (this.$refs.cancelDealForm.validate()) {
        this.$store.dispatch(dealsActionTypes.updateFailure, {
          deal_id: this.deal_id,
          failure_type_id: this.select_cancelDeal
        })
            .then((response) => {
              if (response.success)
                this.fetchFeed(this.client_id)
              this.dialogCancelStage = false
            })
      }
    },
    changeState(id) {
      if (id === true) {
        this.unsetClient = false;
      } else {
        this.unsetClient = true
      }
    },
    changePersonalManager(){
      this.dialogPersonalManager = true;
    },
    addRelation() {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.dialog = true;
    },
    addRelationSubmit() {
      if (this.$refs.relationForm.validate()) {
        if (this.unsetClient === true) {
          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            phone: this.phone,
            first_name: this.first_name,
            last_name: this.last_name,
            middle_name: this.middle_name,
            date_birthday: this.date_birthday,
            gender: this.gender,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            unset_client: this.unsetClient
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                    client_id: this.client_id
                  }).then((response) => {
                    if (response.success) {
                      this.dialog = false;
                    } else {
                      alert('Ошибка данных!')
                      this.dialog = false
                    }
                  });
                } else {
                      alert('Ошибка данных!')
                      this.dialog = false
                    }
              })
        } else {
          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            relative_id: this.select,
            unset_client: this.unsetClient
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                    client_id: this.client_id
                  }).then((response) => {
                    if (response.success) {
                      this.dialog = false
                    } else {
                      alert('Ошибка данных!')
                      this.dialog = false
                    }
                  });
                } else {
                  alert('Ошибка данных!')
                  this.dialog = false
                }
              })
        }
      }
    },
    editRelation(item) {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList)
          .then((response) => {
            if (response.success) {
              this.dialogRelationEdit = true;
            }
          });
      this.editRelationItems.id = item.id;
      this.editRelationItems.name = item.full_name;
      this.editRelationItems.relative_type = item.relatives_type.id;
      this.editRelationItems.is_representative = item.is_representative;
      this.editRelationItems.main_bill = item.shared_main_bill ? 1 : 2;
      this.editRelationItems.bonus_bill = item.shared_bonus_bill ? 1 : 2;

    },
    editRelationSubmit() {
      if (this.$refs.editRelationForm.validate()) {
        this.$store.dispatch(relativesActionTypes.relativesEdit, {
          client_id: this.client_id,
          relative_id: this.editRelationItems.id,
          relative_type: this.editRelationItems.relative_type,
          is_representative: this.editRelationItems.is_representative,
          main_bill_type: this.editRelationItems.main_bill === 1,
          bonus_bill_type: this.editRelationItems.bonus_bill === 1
        })
            .then((response) => {
              if (response.success) {
                this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                  client_id: this.client_id
                }).then((response) => {
                  if (response.success)
                    this.dialogRelationEdit = false;
                });
              }
            })
      }
    },
    deleteRelationSubmit() {
      this.$store.dispatch(relativesActionTypes.relativesRemove, {
        client_id: this.client_id,
        relative_id: this.editRelationItems.id,
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              }).then((response) => {
                if (response.success)
                  this.dialogRelationEdit = false;
              });
            }
          })
    },
    addCard() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(clientActionTypes.cardAdd, {
          client_id: this.client_id,
          card_number: this.card_number,
        })
            .then((response) => {
              if (response.success) {
                this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                  client_id: this.client_id
                }).then((response) => {
                  if (response.success) {
                    this.$refs.form.reset();
                    this.card_number = null;
                    this.dialogCard = false;
                  }
                });
              }
            })
      }
    },
    cardInfo(card) {
      this.chosenCard = card;
      let card_id = card.card_id
      this.$store.dispatch(clientActionTypes.cardInfo, {card_id}).then((response) => {
        if (response.success)
          this.dialogCardEdit = true;
      });
    },
    unlock(card_id) {
      this.$store.dispatch(clientActionTypes.cardUnlock, {
        card_id: card_id
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              }).then((response) => {
                if (response.success)
                  this.dialogCardEdit = false;
              });
            }
          })
    },
    block(card_id) {
      this.$store.dispatch(clientActionTypes.cardBlock, {
        card_id: card_id
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              }).then((response) => {
                if (response.success)
                  this.dialogCardEdit = false;
              });
            }
          })
    },
    addTask() {
      this.$store.dispatch(monitorActionTypes.getListTask)
          .then((response) => {
            if (response.success)
              this.newTask.date = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString();
              let hours = new Date().getHours()
              let minut = new Date().getMinutes()
              let addTime = '00'
              if(minut <= 30 ) {
                addTime = '30'
              } else {
                hours = hours + 1
              }
              this.newTask.time = (hours).toString()+':'+addTime
              this.newTask.specialist_id ={
                id:getItem('user_id_1c'),
                name:getItem('fio')
              }
              this.dialogTask = true;
          });
    },
    addTaskSubmit() {
      if (this.$refs.addTaskForm.validate()) {

        console.log(this.newTask.date)

        let ddate

        if(this.newTask.date.split('T')[1]){
          ddate = this.newTask.date.split('T')[0]
        } else {
          ddate = this.newTask.date
        }

        this.$store.dispatch(tasksActionTypes.tasksAdd, {
          client_id: this.client_id,
          deal_id: this.newTask.deal,
          type_id: this.newTask.type,
          date_end: ddate,
          name: this.newTask.topic,
          description: this.newTask.message ? this.newTask.message : (this.newTask.description ? this.newTask.description : ''),
          status: false,
          specialist_id: this.newTask.specialist_id.id,
          notification_status: this.newTask.notification_status,
          time_end: ddate+'T'+this.newTask.time
        })
            .then((response) => {
              if (response.success) {
                this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                  client_id: this.client_id
                }).then((response) => {
                  if (response.success) {
                    this.dialogTask = false;
                    this.newTask.deal = null;
                    this.newTask.type = null;
                    this.newTask.date = null;
                    this.newTask.topic = null;
                    this.newTask.message = null;
                    this.newTasknofification_status = 1;
                    this.newTask.time = null
                    this.$refs.addTaskForm.reset()
                  }
                });
              }
            });
      }
    },
    editTaskModal(task) {
      console.log(task)
      if(this.taskchecked) {
        return;
      }
      this.$store.dispatch(monitorActionTypes.getListTask)
          .then((response) => {
            if (response.success) {
              this.editTask.id = task.id;
              this.editTask.deal = task.deal;
              this.editTask.type = task.id;
              this.editTask.topic = task.name;
              this.editTask.user = task.user;
              this.editTask.message = task.message ? task.message : (task.description ? task.description : ''),
              this.editTask.description = task.description ? task.description : '';
              this.editTask.date = (task.done && task.done !== false) ? task.date_end : this.formatDateTime(task.assigned_to);
              this.editTask.assigned_to = task.assigned_to
              this.editTask.date_create = task.date_create
              this.editTask.time = task.assigned_to.split('T')[1].split(':')[0] + ':' + task.assigned_to.split('T')[1].split(':')[1]
              this.editTask.type_id = task.type_id
              this.editTask.specialist_id = task.specialist_id ? task.specialist_id : task.user.id
              this.editTask.notification_status = task.remind
              this.dialogEditTask = true;
              if(task.name.split('Звонок')[1]){
                this.editTask.type = "0055a2cb-5917-11e8-814d-9c5c8e747603"
              } else {
                this.editTask.type = "0055a2ce-5917-11e8-814d-9c5c8e747603"
              }
              console.log(this.editTask)
            }
          });
    },
    editTaskSubmit() {
      if (this.$refs.editTaskForm.validate()) {
        this.$store.dispatch(tasksActionTypes.tasksEdit, {
          client_id: this.client_id,
          task_id: this.editTask.id,
          deal_id: this.editTask.deal,
          type_id: this.editTask.type_id,
          date_start: this.editTask.assigned_from,
          date_end: this.editTask.assigned_to,
          name: this.editTask.topic,
          description: this.editTask.description,
          status: false,
          time_end: this.editTask.assigned_to.split('T')[1] ? (this.editTask.assigned_to.split('T')[0]+'T'+this.editTask.time) : this.editTask.assigned_to+'T'+this.editTask.time,
          notification_status: this.editTask.notification_status,
          specialist_id: this.editTask.specialist_id
        }).then((response) => {
          if (response && response.success) {
            this.$store.dispatch(receptionActionTypes.desktopClientSale, {
              client_id: this.client_id
            }).then((response) => {
              if (response && response.success) {
                this.$refs.editTaskForm.reset()
                this.editTask.id = null;
                this.editTask.type = null;
                this.editTask.date = null;
                this.editTask.topic = null;
                this.editTask.message = null;
                this.editTask.description = null;
                this.editTask.specialist_id = null;
                this.dialogEditTask = false;
              }
            })
          }
          this.dialogEditTask = false;
        });
      }
    },
    checkTask(task_id, done) {
      this.taskchecked = true
      this.$store.dispatch(tasksActionTypes.tasksCheck, {
        task_id,
        done
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              });
            }
            this.taskchecked = false
          });
    },
    deleteTask(task_id) {
      this.$store.dispatch(tasksActionTypes.tasksRemove, {
        task_id
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              }).then((response) => {
                if (response.success) {
                  this.$refs.editTaskForm.reset()
                  this.editTask.id = null;
                  this.editTask.type = null;
                  this.editTask.date = null;
                  this.editTask.topic = null;
                  this.editTask.message = null;
                  this.dialogEditTask = false;
                }
              });
            }
          });
    },
    addNote() {
      if (this.$refs.addNoteForm.validate()) {
        this.$store.dispatch(notesActionTypes.notesAdd, {
          client_id: this.client_id,
          note: this.newNote.note,
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(receptionActionTypes.desktopClientSale, {
              client_id: this.client_id
            }).then((response) => {
              if (response.success) {
                this.$refs.addNoteForm.reset()
                this.newNote.note = null;
                this.dialogNote = false;
              }
            })
          }
        });
      }
    },
    editNoteModal(note) {
      this.editNote.id = note.id;
      this.editNote.note = note.note;
      this.dialogEditNote = true;
    },
    editNoteSubmit() {
      if (this.$refs.editNoteForm.validate()) {
        this.$store.dispatch(notesActionTypes.notesEdit, {
          client_id: this.client_id,
          note_id: this.editNote.id,
          note: this.editNote.note
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(receptionActionTypes.desktopClientSale, {
              client_id: this.client_id
            }).then((response) => {
              if (response.success) {
                this.$refs.editNoteForm.reset()
                this.editNote.id = null;
                this.editNote.note = null;
                this.dialogEditNote = false;
              }
            })
          }
        });
      }
    },
    addTag() {
      this.$store.dispatch(tagsActionTypes.tagsList)
          .then((response) => {
            if (response.success) {
              this.listTagsDef = response.tags
              this.listTagsChosed = []
              this.selectTag = []
              for(var u in this.visitorDesktop.client.tags){
                
                let tagObj = {}
                tagObj.id = this.visitorDesktop.client.tags[u].tag_id
                tagObj.name = this.visitorDesktop.client.tags[u].tag_name
                this.selectTag.push(tagObj)
                this.listTagsChosed.push(tagObj)
              }
              this.listTagsChosedDef = this.listTagsChosed
              this.dialogTag = true;
            }
              
          });
    },
    addTagSubmit() {
      let tags = [];
      for (let tag of this.selectTag) {
        tags.push(tag.id)
      }

      // if(this.visitorDesktop.client.tags && this.visitorDesktop.client.tags.length > 0) {
      //   for (let tag2 of this.visitorDesktop.client.tags) {
      //     tags.push(tag2.tag_id)
      //   }
      // }

      console.log(tags);
      this.$store.dispatch(tagsActionTypes.tagsClientUpdate, {
        client_id: this.client_id,
        tags
      })
          .then((response) => {
            if (response.success)
              this.dialogTag = false;
              this.visitorDesktop.client.tags = []
              for (let tag of this.selectTag) {
                let tegObj = {}
                tegObj.tag_id = tag.id
                tegObj.tag_name = tag.name
                this.visitorDesktop.client.tags.push(tegObj)
              }
              
              this.dialogTag = false;
          });
    },
    submitTag() {
      if (this.$refs.tagAddForm.validate()) {
        this.$store.dispatch(tagsActionTypes.tagsAdd, {
          name: this.tag.name
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(tagsActionTypes.tagsList)
                .then((response) => {
                  if (response.success)
                    this.dialogAddTag = false;
                })
          }
        })
      }
    },
    modalPayment() {
      this.$store.dispatch(billActionTypes.getListBill, {
        client_id: this.client_id
      }).then((response) => {
        if (response.success) {
          this.cashbox = this.listCashbox ? this.listCashbox[0].serial : null;
          this.dialogDebitPayment = true;
        }
      });
    },
    modalBillPayment() {
      console.log(this.listCashbox)
      if(!this.listCashbox || this.listCashbox == null){
        alert('Не выбрана касса!')
      } else {
        this.cashbox_debit = this.listCashbox[0].serial;
      }
      this.dialogPayment = true;
      
      this.$store.dispatch(billActionTypes.getListBill,{client_id: this.client_id});
    },
    modalPhone(phone) {
      //if (confirm('Вы собираетесь позвонить клиенту. Продолжить?')) {
        console.log(phone)
        this.$store.dispatch(uisActionTypes.callOut, {
          contact: phone
        })
            .then((response) => {
              if (response.error) {
                alert(response.message);
              }
            });
      //}
    },
    submitFormMakePayment() {
      if (this.$refs.formPayment.validate()) {
        this.$store.dispatch(cashboxActionTypes.saleReceipt, {
          till_id: this.cashbox_debit,
          type: this.dialogTypeOfPayment + 4,
          service_list: [
            {
              price: this.make_summ,
              sum: this.make_summ,
              count: 1,
              name: "Взнос на лицевой счет",
            }
          ]
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(accountActionTypes.makePayment, {
              client_id: this.client_id,
              bill_id: this.bill_debit,
              till_id: this.cashbox_debit,
              make_summ: this.make_summ,
              check_number: response.receipt_number,
              type: this.dialogTypeOfPayment + 1,
              terminal_id: (this.dialogTypeOfPayment + 1) === 2 ? this.cashboxTerminal : null,
              transaction_id: (this.dialogTypeOfPayment + 1) === 2 ? response.auth_code : null,
              transaction_date: (this.dialogTypeOfPayment + 1) === 2 ? new Date() : null,
            })
                .then(() => {
                  this.fetchFeed(this.client_id)
                  this.dialogPayment = false;
                })
          }
        })

      }
    },
    makePayment() {
      if (this.$refs.creditsForm.validate()) {


        console.log('Определим нужную кассу для кредитов')

        let cresditCashboxes = this.listCashbox.filter(cashboxItem => {
            return this.credits.some(creditItem => cashboxItem.inn === creditItem.org.org_inn);
        });

        if(cresditCashboxes && cresditCashboxes.serial) {
          this.cashbox = cresditCashboxes.serial
        }


        this.$store.dispatch(cashboxActionTypes.multiplePayment, {
          till_id: this.cashbox,
          type: this.dialogDebitTypeOfPayment + 1,
          bill_id: (this.dialogDebitTypeOfPayment + 1) === 2 ? this.main_bill_debit?.deposit_id : null,
          credit_list: this.credits
        })
            .then((response) => {
              if (response.success) {
                this.fetchFeed(this.client_id);
                this.dialogDebitPayment = false;
                this.main_bill_debit = null;
                this.chosenAmountDebt = 0;
                this.credits = [];
              }
            })
      }
    },
    cancelReceipt() {
      this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
        till_id: this.cashbox
      })
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          console.log('RESSS' + xmlhttp.responseText)
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
            if (xmlhttp.responseText.length > 0) {
              if (!vm.cardRightNow) {
                var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                transformArray.reverse();
                var resultString = transformArray.join('') + '000000';
                console.log(resultString);
                console.log('Card has been placed on reader: ' + resultString); // action here!!!!

                //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                vm.fetchFeedCard(resultString);
                vm.cardRightNow = true;
              }
            } else {
              vm.counterInterval = setInterval(vm.sendRequest, 1000);
              if (vm.cardRightNow) {
                cardRightNow = false;
                console.log('no card');
                console.log('Card has been removed from reader: '); //card removed (may be needed in future)
              }
            }
          } else if (xmlhttp.status == 400) {
            console.log('There was an error 400');
          } else {
            console.log('something else other than 200 was returned');
          }

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    },
    stopCard(){
      clearInterval(this.counterInterval)
    },
    searchBracelet() {
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    updateClient() {
      let updObj = {}
        updObj.client_id = this.client_id
      if(this.client_new_manager){
        updObj.manager_id = this.client_new_manager.id
        this.visitorDesktop.client.manager.id = this.client_new_manager.id
        this.visitorDesktop.client.manager.name = this.client_new_manager.name
      }
      if(this.advertising_platform_new){
        updObj.platform_id = this.advertising_platform_new.id
        this.visitorDesktop.client.advertising_platform.id = this.advertising_platform_new.id
        this.visitorDesktop.client.advertising_platform.name = this.advertising_platform_new.name
      }
      if(this.advertising_source_new){
        updObj.source_id = this.advertising_source_new.id
        updObj.advertising_source_value = this.select
        this.visitorDesktop.client.advertising_source.id = this.advertising_source_new.id
        this.visitorDesktop.client.advertising_source.name = this.advertising_source_new.name
        this.visitorDesktop.client.advertising_source_value = this.select
      }
      this.dialogPersonalManager = false
        this.dialogPersonalPlatform = false
        this.dialogPersonalSource = false
      this.$store.dispatch(clientActionTypes.updateClient, updObj).then((response) => {
        this.dialogPersonalManager = false
        this.dialogPersonalPlatform = false
        this.dialogPersonalSource = false
        console.log(response)
      }).then(() => {
          //this.$router.push({ name: 'Desktop', params: { client_id: this.client_id } })
          this.fetchFeed(this.client_id)
      })
    }
  }
}

</script>
<style scoped lang="scss">
.status-line {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__status {
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    padding: 8px 12px;
    color: #767676;
    cursor: default;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &.active {
      background: #FFFEB2;
      color: #000;
      border-color: #FFFEB2;
    }
  }
}

.grid {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 20px;
  padding-top: 20px;

  .block {
    background: #fff;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    &.padding-20 {
      padding: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 20px;

    }

    &.margin-bottom-10 {
      margin-bottom: 10px;
    }

    button.gray {
      background: #F1F1F1;
      border-radius: 12px;
      text-transform: none;
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      border: none;
      width: 100%;
      box-shadow: unset;
    }
  }

  .client-info {
    .personal-data {
      padding: 20px;
      border-bottom: 1px solid #E0E0E0;
      display: flex;
      flex-direction: column;
      align-items: center;

      &__photo {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #F1F1F1;

        img {
          max-width: 100%;
          max-height: 100%;
          border-radius: 50%;
        }
      }

      &__info {
        text-align: center;
        padding: 20px 0;

        .fio {
          color: #1A1A1A;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          padding-bottom: 4px;
        }

        .birthday-reg-day {
          color: #1A1A1A;
          opacity: .5;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;

          span {
            display: block;
          }
        }
      }
    }

    .personal-info {
      padding: 20px;

      .item {
        width: 100%;
        font-family: 'Circe';
        font-weight: 400;
        font-style: normal;

        .active_status {
          color: #629F33 !important;
        }

        .block_status {
          color: #D53025 !important;
        }

        &:not(:last-child) {
          margin-bottom: 20px;
        }

        &__grid {
          display: grid;
          grid-template-columns: 1fr 63px;
        }

        &__head {
          color: #1A1A1A;
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 14px;

          .right {
            &.buttons-block {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            &.justify-flex-end {
              display: flex;
              justify-content: flex-end;
            }

            button.gray {
              padding: 4px 8px;
              border-radius: 25px;
              font-size: 13px;
              line-height: 16px;
              color: #1A1A1A;
              height: 24px !important;
            }
          }
        }

        &__value {
          color: #767676;
          font-size: 13px;
          line-height: 16px;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .right {
            &.text-right {
              text-align: right;
            }

            &.color-black {
              color: #1A1A1A;
            }
          }
        }

        .btn-icon {
          width: 24px;
          height: 24px;
          background: #F1F1F1;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .3s;

          &:hover {
            background: #e0e0e0;
          }
        }
      }
    }
  }

  .client-data {
    .personal-account {
      &__status {
        padding: 20px;
        color: #D53025;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }

      table {
        border-collapse: collapse;
        width: 100%;

        thead {
          th {
            background: #F1F1F1;
            font-weight: bold;
          }
        }

        th,
        td {
          background: #fff;
          padding: 10px 12px;
          text-align: left;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          color: #000000;
          border: 1px solid #E0E0E0 !important;

          &:first-child {
            border-left: 0 !important;
            width: 50px;
            max-width: 50px;
          }

          &:nth-child(2) {
            width: 100%;
          }

          &:nth-child(3) {
            min-width: 107px;
          }

          &:last-child {
            border-right: 0 !important;
            min-width: 107px;
          }

          .v-input__slot {
            margin: 0 !important;
          }

          .v-messages {
            display: none;
          }

          .v-input--selection-controls__ripple {
            display: none;
          }

          .v-input--checkbox {
            margin-top: 0 !important;
          }
        }

        td {
          vertical-align: top;

          .cheque {
            width: 100%;

            &__name {
              display: flex;
              align-items: center;

              span {
                flex: 1;
              }

              button {
                svg {
                  transition: all .3s;
                }

                &.open {
                  svg {
                    transform: rotate(180deg);
                  }
                }
              }
            }
          }
        }

      }

      &__payment {
        padding: 20px;
        display: flex;
        justify-content: flex-end;

        button.red {
          background: #D53025;
          border-radius: 12px;
          text-transform: none;
          color: #fff;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          border: none;
          box-shadow: unset;
        }
      }
    }

    .buttons-block {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;

      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .task-buttons {
      padding: 20px;
      border-bottom: 1px solid #E0E0E0;

      button {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    .tags-list {
      display: flex;
      padding: 20px;
      border-bottom: 1px solid #E0E0E0;
      .tag-item {
        margin: 5px;
        border-radius: 5px;
      }
    }

    .task-list {
      padding: 20px;

      &__day {
        &:not(:last-child) {
          margin-bottom: 20px;
        }

        &__day-name {
          display: flex;
          justify-content: center;

          span {
            background: #F1F1F1;
            border-radius: 15px;
            color: #1A1A1A;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            padding: 4px 10px;
          }
        }

        &__tasks {

          width: 100%;
          padding: 18px 0;


          &__task {
            width: 100%;
            border-radius: 12px;
            border: 1px solid #E0E0E0;

            &:not(:last-child) {
              margin-bottom: 10px;
            }

            .task-header {
              padding: 11px 13px;
              display: flex;
              align-items: center;
              background: #F1F1F1;
              color: #767676;
              font-family: 'Circe';
              font-style: normal;
              font-weight: 400;
              font-size: 10px;
              line-height: 12px;

              svg {
                margin-right: 10px;
              }

              .task-date {
              }

              .task-title {
                flex: 1;
                text-align: right;
                color: #1A1A1A;
              }
            }

            .task-content {
              display: grid;
              grid-template-columns: 100%;
              padding-top: 10px;
              color: #1A1A1A;
              font-family: 'Circe';
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 16px;

              .task-text {
                padding-left: 11px;
                padding-bottom: 10px;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
                color: #1A1A1A;
              }

              &.content-grid {
                grid-template-columns: 40px 1fr;
                align-items: flex-start;

                .check-div {
                  padding-left: 10px;

                  .v-input--checkbox {
                    transform: scale(.75);
                    padding: 0 !important;
                    top: -5px;
                    position: relative;

                    i {
                      font-size: 23px;
                      color: #1A1A1A !important;
                    }
                  }

                  .v-input__slot {
                    margin: 0 !important;
                  }

                  .v-messages {
                    display: none;
                  }

                  .v-input--selection-controls__ripple {
                    display: none;
                  }

                  .v-input--checkbox {
                    margin-top: 0 !important;
                  }
                }

                .task-topic {
                  color: #1A1A1A;
                  font-family: 'Circe';
                  font-style: normal;
                  font-weight: 700;
                  font-size: 13px;
                  line-height: 16px;
                  display: block;
                  margin-bottom: 4px;
                }
              }
            }
          }
        }

        &__history {

          &__item {
            display: flex;
            align-items: center;

            &:not(:last-child) {
              margin-bottom: 10px;
            }

            .action {
              color: #767676;
              font-family: 'Circe';
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 16px;

              .status {
                background: #EFF5EB;
                border-radius: 25px;
                padding: 4px 10px;
                color: #629F33;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
              }
            }

            .separator {
              transform: rotate(-90deg);
              padding: 0 14px;
            }
          }
        }

      }
    }
  }

}

.my-btn {
  border-radius: 12px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  border: none;
  box-shadow: unset;
  padding: 8px 12px;

  &.green {
    background: #E0ECD6 !important;
    color: #629F33;
  }

  &.text {
    background: unset !important;;
    color: #767676;
  }

  &.gray {
    width: unset !important;
  }

  &.red {
    background: #D53025 !important;
    color: #fff !important;
  }

  &.border-green {
    background: unset !important;
    color: #629F33;
    border: 1px solid #629F33;
  }

  &.margin-right-20 {
    margin-right: 20px;
  }
}

.modal-content {
  .block {
    background: #fff;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    &.padding-20 {
      padding: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .block-button {
      padding: 20px 0 20px 20px;
    }

    .label {
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.padding-20 {
        padding: 20px;
      }

      .status {
        background: #FFB800;
        border-radius: 25px;
        padding: 4px 10px;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }

    .relatives {
      table {
        border-collapse: collapse;
        width: 100%;

        thead {
          th {
            background: #F1F1F1;
            font-weight: bold;
          }
        }

        th,
        td {
          background: #fff;
          padding: 7px 12px;
          text-align: left;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          color: #000000;
          border: 1px solid #E0E0E0 !important;
        }

        td {
          .relative {
            display: flex;
            align-items: center;

            .ava {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 8px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  .client-photo {
    display: flex;
    flex-direction: column;
    align-items: center;

    .photo {
      width: 210px;
      height: 210px;
      background: #F1F1F1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-top: 19px;
      margin-bottom: 20px;
    }

    .block-btn {
      margin-bottom: 20px;
    }
  }

  .form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;

    &__item {
      width: calc(50% - 10px);
      margin-bottom: 20px;

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &.padding-top-30 {
        padding-top: 30px;
      }

      .v-input__slot {
        height: 55px !important;
        max-height: 55px !important;

        fieldset {
          height: 55px !important;
          max-height: 55px !important;
        }

        .v-text-field__slot {
          height: 50px !important;
        }
      }

      &.w-100 {
        width: 100%;
      }
    }

  }
}

.custom__date-button {
  background: none !important;
  border: 1px solid #E0E0E0 !important;
  padding: 12px 16px !important;
  width: 100% !important;
  color: #767676 !important;

  .v-icon {
    color: #767676 !important;
    font-size: 20px !important;
  }

  .full-width {
    flex: 1;
    text-align: left;
  }
}

.payment-form {
  &__item {
    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .v-btn-toggle {
      margin: 0 !important;
    }

    // .v-select__slot,
    // fieldset,
    // .v-text-field__slot,
    // .v-input__slot,
    .v-input__control,
    .v-input__slot {
      max-height: 48px !important;
      min-height: 48px !important;
      height: 48px !important;
    }

    .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
      height: 48px !important;
    }

    .theme--light.v-btn.v-btn--has-bg {
      background-color: #fff;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-transform: none;
    }

    .v-select__selections {
      padding: 0 !important;
    }

    .theme--light.v-btn--active:hover::before,
    .theme--light.v-btn--active::before {
      opacity: 0;
    }


    .line {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 65%;
      gap: 10px;

      span {
        flex: 1;
        text-align: right;
      }

      .v-btn-toggle {
        margin: 0 !important;

        .v-btn__content {
          font-family: 'Circe';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          // color: #629F33;
          display: flex;
          align-items: center;
          text-transform: none;

          svg {
            margin-right: 10px;
          }

          .v-btn {
            background: #fff !important;
          }

          &--active {
            background: #fff !important;
          }
        }
      }
    }

    .collumn-3 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 21px;

      .disabled {
        background: #F1F1F1;
      }
    }
  }
}

.relatives-block {
  &.see {
    padding-top: 30px;
  }

  .toggle-line {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .form-grid {
    &__line {
      display: grid;
      grid-template-columns: repeat(3, calc(33.3333% - 18px));
      gap: 18px;

      &.line-col-2 {
        align-items: center;
        grid-template-columns: calc(33.3333% - 18px) 1fr;

        .label {
          // margin-bottom: 0;
        }
      }

      &.margin-bottom-20 {
        margin-bottom: 20px;
      }

      &__field {
        &.requred {
          .label {
            &::after {
              content: " *";
              color: #D53025;
            }
          }
        }

        &.colspan-2 {
          grid-column: 1 / 3;
        }

        &.button-block {
          display: flex;
          align-items: center;
        }

        .label {
          display: inline-block;
          margin-bottom: 8px;

          &.opacity-0 {
            opacity: 0;
          }
        }

        .v-autocomplete {
          .v-select__slot {
            height: 48px;

            input {
              margin: 0 !important;
            }
          }
        }

        input {
          margin: 8px 0;
        }

        .vd-activator {
          margin: 0 !important;
          padding: 0 !important;

          .custom__date-button {
            justify-content: space-between;
            box-sizing: border-box;
            min-width: 100% !important;
            height: 48px !important;

            i {
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        }

        .v-item-group {
          border-radius: 12px !important;
          background: #fff !important;

          button {
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            text-transform: none;
            background: #fff !important;
            height: 48px !important;

            &::before {
              display: none;
            }
          }
        }

        .v-select__slot {

          .v-select__selections {
            input {
              padding: 0 !important;
              margin: 10px 0 !important;
            }
          }

          .v-input__append-inner {
            margin-top: 12px !important;
          }
        }

        i {
          color: #767676 !important;
          caret-color: #767676 !important;
        }

        .dt-error {
          line-height: 12px;
          word-break: break-word;
          overflow-wrap: break-word;
          word-wrap: break-word;
          -webkit-hyphens: auto;
          -ms-hyphens: auto;
          hyphens: auto;
          color: #ff5252;
          font-size: 12px;
          padding: 0 12px;
          padding-top: 4px;
          margin-bottom: -10px;
        }
      }

      .link-btn {
        border: 1px solid #629F33;
        border-radius: 12px;
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        text-decoration: none;
        color: #629F33;
        margin-top: 30px;
      }
    }

    button {

      &[type="submit"],
      &.delete {
        background: #629F33;
        border-radius: 12px;
        padding: 12px 20px;
        box-shadow: none;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        height: unset !important;
        margin-top: 0 !important;
      }

      &.delete {
        background: #D53025;
        margin-left: 19px;
      }
    }
  }
}

.new-task {
  &.card {
    padding: 0 24px;

    .grid-line {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .v-text-field__slot {
        height: 48px;
      }

      button {
        background: #A13453 !important;
        border-radius: 12px;
        text-transform: none;
        padding: 0 20px;
        display: flex;
        align-items: center;
        margin-top: 0px !important;
        margin-left: 8px;
        box-shadow: unset !important;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
        height: 48px !important;
        min-height: 48px !important;
      }
    }

    .button-block {
      padding-top: 40px;
      justify-content: center;

      button {
        &[type="submit"] {
          padding: 12px 20px;
          height: unset !important;
        }

        &[disabled] {
          color: #1A1A1A !important;
        }
      }
    }
  }

  &.card-edit {
    form {
      width: 288px;
      margin: auto;

      .form-field {
        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .v-input__slot {
          height: 48px;
          min-height: 48px;
          max-height: 48px;
        }
      }

      .message-hint {
        color: #767676;
        text-align: center;
        padding-top: 20px;
      }

      .button-block {
        padding-top: 42px;
        justify-content: center;

        button {
          &[type="submit"] {
            padding: 12px 20px;
            height: unset !important;
            background: #D53025 !important;
          }
        }
      }
    }
  }

  .heading {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    color: #000000;
    margin-bottom: 24px;
  }

  .form-field {
    .label {
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      display: block;
      margin-bottom: 8px;
    }
  }

  .button-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      &[type="submit"] {
        background: #629F33;
        border-radius: 12px;
        padding: 8px 20px;
        box-shadow: none;
        text-transform: none;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px !important;
  color: #767676 !important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}

.purpure-button {
  background-color: #A13453 !important;
}

.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}
</style>